import MotivationStats from './MotivationStats';
import { useLocation, useNavigate } from 'react-router-dom';
import { useEffect, useState, useRef } from 'react';
import StatusProgres from '../../progressbar/StatusProgres';
import './chaptercontainer.css';
import finishLesson from '../../imagesHome/finish_lesson.gif';
import '../../styles/darkmode.css';
import PracticeHelpPopup from './PracticeHelpPopup';
import final_congrats_conti from '../../imagesHome/final_congrats_conti.png';
import finishflag from '../../imagesHome/finish-flag.png';
import changecard from '../../imagesHome/change-card.png';
import Junphereconti from '../../imagesHome/Junphereconti.png';


import confettyFinish from '../../imagesHome/confettyFinish.gif';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faThumbsUp, faThumbsDown, faStar, faSquareCheck } from "@fortawesome/free-regular-svg-icons";
import { faCheckDouble, faGift } from "@fortawesome/free-solid-svg-icons";
import StreakDisplay from './StreakDisplay';



import { useCallback } from 'react';
import levelUp from '../../header/images/level-up.mp3';
import error from '../../header/images/error.mp3';
import { CSSTransition, SwitchTransition } from 'react-transition-group';
import CustomAlert from '../../progressbar/CustomAlert'; 
import FeedbackPopup from '../../popuplessons/FeedbackPopup';
import ExplanationPopup from '../../popuplessons/ExplanationPopup';

import fire from '../../imagesHome/fire.gif';
import NoLivesPopup from '../../progressbar/NoLivesPopup';

import Leaderboard from '../clasament/Leaderboard';
import finallessonprogress from '../../imagesHome/finallessonprogress.gif';













  // Adaugă URL-ul API-ului folosind variabila de mediu
  const apiUrl = process.env.REACT_APP_API_URL;

  // Adaugă această funcție pentru a iniția vibrația pe dispozitivele compatibile
const triggerVibration = (pattern) => {
  if (navigator.vibrate) {
    navigator.vibrate(pattern);
  }
};




const shuffleArray = (array) => {
  const shuffled = [...array];
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }
  return shuffled;
};



const Chaptercontainer = () => {

  const buildDecisionOptionId = (index) => `decision-opt-${index}`;

  const extractDecisionOptionIndex = (optionId) => {
    if (typeof optionId !== 'string') return -1;
    if (!optionId.startsWith('decision-opt-')) return -1;
    const value = Number(optionId.replace('decision-opt-', ''));
    return Number.isInteger(value) && value >= 0 ? value : -1;
  };

  const getDecisionOptionValueById = (step, optionId) => {
    const index = extractDecisionOptionIndex(optionId);
    if (index !== -1) {
      if (!Array.isArray(step?.options)) return null;
      return step.options[index] ?? null;
    }

    if (optionId === null || optionId === undefined || optionId === '') {
      return null;
    }

    return optionId;
  };

  const buildGeneralOptionId = (index) => `general-opt-${index}`;

  const extractGeneralOptionIndex = (optionId) => {
    if (typeof optionId !== 'string') return -1;
    if (!optionId.startsWith('general-opt-')) return -1;
    const value = Number(optionId.replace('general-opt-', ''));
    return Number.isInteger(value) && value >= 0 ? value : -1;
  };

  const getGeneralOptionValueById = (question, optionId) => {
    const index = extractGeneralOptionIndex(optionId);
    if (index === -1) return null;
    if (!Array.isArray(question?.options)) return null;
    return question.options[index] ?? null;
  };

  const getDecisionDragSlotsCount = (step) => {
    if (!step || typeof step !== 'object') return 0;
    const explicitCount = Number(step.slotsCount);
    if (Number.isFinite(explicitCount) && explicitCount > 0) {
      return explicitCount;
    }
    if (Array.isArray(step.rows)) {
      const rowsCount = step.rows.reduce((sum, row) => {
        const slots = Number(row?.slots);
        return sum + (Number.isFinite(slots) && slots > 0 ? slots : 0);
      }, 0);
      if (rowsCount > 0) return rowsCount;
    }
    return Array.isArray(step.correctAnswer) ? step.correctAnswer.length : 0;
  };

  const buildHorizontalOptionId = (index) => `horizontal-opt-${index}`;

  const extractHorizontalOptionIndex = (optionId) => {
    if (typeof optionId !== 'string') return -1;
    if (!optionId.startsWith('horizontal-opt-')) return -1;
    const value = Number(optionId.replace('horizontal-opt-', ''));
    return Number.isInteger(value) && value >= 0 ? value : -1;
  };

  const getHorizontalOptionValue = (option) => {
    if (option && typeof option === 'object') {
      return option.code ?? option.value ?? option.label ?? '';
    }
    return option;
  };

  const normalizeHorizontalDragOptions = (question) => {
    if (!Array.isArray(question?.options)) return [];

    return question.options.reduce((acc, option, index) => {
      const value = getHorizontalOptionValue(option);
      const normalizedValue = value === null || value === undefined ? '' : String(value).trim();

      // Ignoram optiunile goale pentru a evita butoane fara text.
      if (!normalizedValue) {
        return acc;
      }

      acc.push({
        id: buildHorizontalOptionId(index),
        value: normalizedValue,
        label: option && typeof option === 'object'
          ? String(option.label ?? normalizedValue)
          : normalizedValue,
      });

      return acc;
    }, []);
  };

  const getHorizontalDragSlotsCount = (question) => {
    if (!question || typeof question !== 'object') return 0;

    const explicitCount = Number(question.slotsCount);
    if (Number.isFinite(explicitCount) && explicitCount > 0) {
      return explicitCount;
    }

    if (Array.isArray(question.rows) && question.rows.length > 0) {
      const rowsCount = question.rows.reduce((sum, row) => {
        const slots = Number(row?.slots);
        return sum + (Number.isFinite(slots) && slots > 0 ? slots : 0);
      }, 0);
      if (rowsCount > 0) return rowsCount;
    }

    const countInlineSlotsFromParts = (parts) => {
      if (!Array.isArray(parts) || parts.length === 0) return 0;
      return parts.reduce((count, part) => {
        const text = String(part ?? '');
        const isSlot =
          text === '__SLOT__' ||
          text === '{{slot}}' ||
          /^_{3,}$/.test(text);
        return count + (isSlot ? 1 : 0);
      }, 0);
    };

    const countInlineSlotsFromTemplate = (template) => {
      if (typeof template !== 'string' || template.trim() === '') return 0;
      const matches = template.match(/\{\{slot\}\}|_{3,}/g);
      return Array.isArray(matches) ? matches.length : 0;
    };

    const sentencePartsCount = countInlineSlotsFromParts(question.sentenceParts);
    if (sentencePartsCount > 0) return sentencePartsCount;

    const sentenceTemplateCount = countInlineSlotsFromTemplate(question.sentenceTemplate);
    if (sentenceTemplateCount > 0) return sentenceTemplateCount;

    const questionInlineCount = countInlineSlotsFromTemplate(question.question);
    if (questionInlineCount > 0) return questionInlineCount;

    if (!Array.isArray(question.correctAnswer)) {
      return 0;
    }

    return question.correctAnswer.filter((_, index) => index % 2 === 1).length;
  };

  const getHorizontalDragRows = (question) => {
    if (Array.isArray(question?.rows) && question.rows.length > 0) {
      return question.rows;
    }

    return [{ label: '', slots: getHorizontalDragSlotsCount(question) }];
  };

  const getHorizontalDragExpectedAnswers = (question) => {
    if (!Array.isArray(question?.correctAnswer)) return [];

    if (Array.isArray(question.rows) && question.rows.length > 0) {
      return question.correctAnswer;
    }

    const slotsCount = getHorizontalDragSlotsCount(question);
    if (question.correctAnswer.length === slotsCount) {
      return question.correctAnswer;
    }

    return question.correctAnswer.filter((_, index) => index % 2 === 1);
  };

  const getHorizontalSentenceSegments = (question) => {
    if (!question || typeof question !== 'object') return [];

    if (Array.isArray(question.sentenceParts) && question.sentenceParts.length > 0) {
      return question.sentenceParts;
    }

    if (typeof question.sentenceTemplate === 'string' && question.sentenceTemplate.trim() !== '') {
      const parts = question.sentenceTemplate
        .split(/(\{\{slot\}\}|_{3,})/g)
        .filter((item) => item !== '');

      if (parts.length > 0) {
        return parts;
      }
    }

    if (typeof question.question === 'string' && /\{\{slot\}\}|_{3,}/.test(question.question)) {
      const parts = question.question
        .split(/(\{\{slot\}\}|_{3,})/g)
        .filter((item) => item !== '');

      if (parts.length > 0) {
        return parts;
      }
    }

    // Fallback pentru structura veche: textul era alternat cu raspunsurile corecte.
    if (Array.isArray(question.correctAnswer) && question.correctAnswer.length > 1) {
      const hasRows = Array.isArray(question.rows) && question.rows.length > 0;
      const hasExplicitSlots = Number(question.slotsCount) > 0;

      if (!hasRows && !hasExplicitSlots) {
        return question.correctAnswer.map((item, index) => (index % 2 === 1 ? '__SLOT__' : item));
      }
    }

    return [];
  };

  const getHorizontalOptionValueById = (question, optionId) => {
    const index = extractHorizontalOptionIndex(optionId);
    if (index === -1) {
      if (optionId === null || optionId === undefined || optionId === '') return null;
      return optionId;
    }

    if (!Array.isArray(question?.options)) return null;
    const option = question.options[index];
    const value = getHorizontalOptionValue(option);
    if (value === null || value === undefined || value === '') return null;
    return String(value);
  };

const userId = localStorage.getItem("userId");

  const navigate = useNavigate();




  const [shuffledOptions, setShuffledOptions] = useState([]);
  const [shuffledMultipleOptions, setShuffledMultipleOptions] = useState([]);
  const [shuffledApplicationOptions, setShuffledApplicationOptions] = useState([]);
  const [shuffledDragOneOptions, setShuffledDragOneOptions] = useState([]);
  const [shuffledDragHorizontalOptions, setShuffledDragHorizontalOptions] = useState([]);
  const [shuffledDecisionOptions, setShuffledDecisionOptions] = useState([]);
  const [shuffledDecisionDragOptions, setShuffledDecisionDragOptions] = useState([]);
  const [shuffledGeneralDragOptions, setShuffledGeneralDragOptions] = useState([]);
  const [shuffledOptionDragAndDropFormulaLeftOptions, setShuffledOptionDragAndDropFormulaLeftOptions] = useState([]);
  const [shuffledOptionDragAndDropFormulaRightOptions, setShuffledOptionDragAndDropFormulaRightOptions] = useState([]);

  const [cardIndex, setCardIndex] = useState(0);
  const [leavingCardIndex, setLeavingCardIndex] = useState(null);
  const leaveCardTimerRef = useRef(null);












  const [lives, setLives] = useState(3);
  const [coinCount, setCoinCount] = useState(0);
  const [xp, setXp] = useState(0);
  const [correctStreak, setCorrectStreak] = useState(0);

// 🔥 statistici DOAR pentru lecția curentă
const [lessonCoins, setLessonCoins] = useState(0);
const [lessonXp, setLessonXp] = useState(0);
const [correctAnswersCount, setCorrectAnswersCount] = useState(0);
const [wrongAnswersCount, setWrongAnswersCount] = useState(0);

  

const [selectedRating, setSelectedRating] = useState(0);
const [showRatingMessage, setShowRatingMessage] = useState(false);
const [showRatingSection, setShowRatingSection] = useState(false);
const [decisionStepIndex, setDecisionStepIndex] = useState(0);
const [decisionAnswer, setDecisionAnswer] = useState(null);
const [decisionSelectedAnswers, setDecisionSelectedAnswers] = useState([]); // Pentru multipleOption
const [decisionDragAnswer, setDecisionDragAnswer] = useState([]); // Pentru optionDragAndDrop
const [selectedDecisionDragOptionId, setSelectedDecisionDragOptionId] = useState(null);
const [generalDragAnswer, setGeneralDragAnswer] = useState([]); // Pentru generalOptionDrag
const [orderSelectedSlotIndex, setOrderSelectedSlotIndex] = useState(null);
const [decisionPhase, setDecisionPhase] = useState('intro');
const touchDecisionOptionIdRef = useRef(null);
const touchDecisionStartRef = useRef({ x: 0, y: 0 });
const touchDecisionMovedRef = useRef(false);
const touchDecisionHoveredSlotRef = useRef(null);
const touchDecisionPreviewRef = useRef(null);
const touchDecisionSourceRef = useRef(null);
// 'intro' | 'steps' | 'final'


const [showPracticeHelp, setShowPracticeHelp] = useState(false);


const ignoredForProgress = [
  'lessonResume',
  'JustInTimeMotivation',
  'serieCompleta',
  'deblocarePremium',
  'clasament',
  'lessonCompletion'
];





const handleRating = (value) => {
  setSelectedRating(value);

  // ascunde mesajul întâi
  setShowRatingMessage(false);

  // afișează după 0.2s
  setTimeout(() => {
    setShowRatingMessage(true);
  }, 200);

  handleFeedback(value);
};



    const location = useLocation();
  const { chapterId, lessonId, lessonData: lessonDataFromState } = location.state || {}; // Primește chapterId și lessonId
  const [lessonData, setLessonData] = useState(null);
  const [nextQuestion, setNextQuestion] = useState(0);
  const [showJumpHereIntro, setShowJumpHereIntro] = useState(false);


  
// 🔥 OPREȘTE LECȚIA CÂND VIEȚILE AJUNG LA 0
const [showNoLivesPopup, setShowNoLivesPopup] = useState(false);


useEffect(() => {
  const currentQuestion = lessonData?.questions?.[nextQuestion];





  if (!currentQuestion) return;

  if (currentQuestion.type === 'simpleSelect') {
    setShuffledOptions(shuffleArray(currentQuestion.options));
    setShuffledMultipleOptions([]);
    setShuffledApplicationOptions([]);
    setShuffledDragOneOptions([]);
    setShuffledDragHorizontalOptions([]);
  }

  if (currentQuestion.type === 'multipleSelect') {
    setShuffledMultipleOptions(shuffleArray(currentQuestion.options));
    setShuffledOptions([]);
    setShuffledApplicationOptions([]);
    setShuffledDragOneOptions([]);
    setShuffledDragHorizontalOptions([]);
  }

  if (currentQuestion.type === 'simpleApplication') {
    setShuffledApplicationOptions(shuffleArray(currentQuestion.options));
    setShuffledOptions([]);
    setShuffledMultipleOptions([]);
    setShuffledDragOneOptions([]);
    setShuffledDragHorizontalOptions([]);
  }

  if (currentQuestion.type === 'dragAndDropOneAnswer') {
    setShuffledDragOneOptions(shuffleArray(currentQuestion.options));
    setShuffledOptions([]);
    setShuffledMultipleOptions([]);
    setShuffledApplicationOptions([]);
    setShuffledDragHorizontalOptions([]);
  }

  if (currentQuestion.type === 'dragAndDropHorizontal') {
    setShuffledDragHorizontalOptions(shuffleArray(normalizeHorizontalDragOptions(currentQuestion)));
    setShuffledOptions([]);
    setShuffledMultipleOptions([]);
    setShuffledApplicationOptions([]);
    setShuffledDragOneOptions([]);
  }

  if (currentQuestion.type === 'generalOptionDrag' || currentQuestion.type === 'orderSelectionDrag') {
    setShuffledGeneralDragOptions(
      Array.isArray(currentQuestion.options)
        ? shuffleArray(currentQuestion.options.map((value, index) => ({
            id: buildDecisionOptionId(index),
            value,
            label: String(value),
          })))
        : []
    );
    setShuffledOptions([]);
    setShuffledMultipleOptions([]);
    setShuffledApplicationOptions([]);
    setShuffledDragOneOptions([]);
    setShuffledDragHorizontalOptions([]);
  }

  if (currentQuestion.type === 'optionDragAndDropFormulaLeft') {
    setShuffledOptionDragAndDropFormulaLeftOptions(shuffleArray(currentQuestion.options || []));
    setShuffledOptions([]);
    setShuffledMultipleOptions([]);
    setShuffledApplicationOptions([]);
    setShuffledDragOneOptions([]);
    setShuffledDragHorizontalOptions([]);
    setShuffledGeneralDragOptions([]);
  }

  if (currentQuestion.type === 'optionDragAndDropFormulaRight') {
    setShuffledOptionDragAndDropFormulaRightOptions(shuffleArray(currentQuestion.options || []));
    setShuffledOptions([]);
    setShuffledMultipleOptions([]);
    setShuffledApplicationOptions([]);
    setShuffledDragOneOptions([]);
    setShuffledDragHorizontalOptions([]);
    setShuffledGeneralDragOptions([]);
  }
}, [lessonData, nextQuestion]);



useEffect(() => {
  setCardIndex(0);
  setLeavingCardIndex(null);
}, [nextQuestion]);


const updateCardIndexWithSwipe = useCallback((nextIndex) => {
  if (nextIndex === cardIndex) {
    return;
  }

  setLeavingCardIndex(cardIndex);

  if (leaveCardTimerRef.current) {
    clearTimeout(leaveCardTimerRef.current);
  }

  setCardIndex(nextIndex);

  leaveCardTimerRef.current = setTimeout(() => {
    setLeavingCardIndex(null);
    leaveCardTimerRef.current = null;
  }, 360);
}, [cardIndex]);


useEffect(() => {
  return () => {
    if (leaveCardTimerRef.current) {
      clearTimeout(leaveCardTimerRef.current);
    }
  };
}, []);



useEffect(() => {
  const currentQuestion = lessonData?.questions?.[nextQuestion];

  if (!currentQuestion) return;
  if (currentQuestion.type !== 'decisionFlowApplication') return;

  const step = currentQuestion.steps?.[decisionStepIndex];
  if (!step) return;

  const shuffledOptions = Array.isArray(step.options) ? shuffleArray(step.options) : [];
  setShuffledDecisionOptions(shuffledOptions);

  const normalizedDragOptions = Array.isArray(step.options)
    ? step.options.map((value, index) => ({
        id: buildDecisionOptionId(index),
        value,
        label: String(value),
      }))
    : [];

  const slotsCount = getDecisionDragSlotsCount(step);
  const initialDragAnswer = Array(slotsCount).fill(null);
  const fixedSlotIds = new Set();

  // Sempre aplica prefilledSlots, indiferent de optionType
  if (Array.isArray(step.prefilledSlots)) {
    step.prefilledSlots.forEach((fixedValue, slotIndex) => {
      if (slotIndex < 0 || slotIndex >= slotsCount) return;
      if (fixedValue === null || fixedValue === undefined || fixedValue === '') return;

      const match = normalizedDragOptions.find((option) => {
        return String(option.value).trim() === String(fixedValue).trim() && !fixedSlotIds.has(option.id);
      });

      if (match) {
        initialDragAnswer[slotIndex] = match.id;
        fixedSlotIds.add(match.id);
      } else {
        initialDragAnswer[slotIndex] = fixedValue;
      }
    });
  }

  setShuffledDecisionDragOptions(shuffleArray(
    normalizedDragOptions.filter((option) => !fixedSlotIds.has(option.id))
  ));
  setDecisionDragAnswer(initialDragAnswer);
  setSelectedDecisionDragOptionId(null);
}, [lessonData, nextQuestion, decisionStepIndex]);



useEffect(() => {
  const q = lessonData?.questions?.[nextQuestion];
  if (q?.type === 'decisionFlowApplication') {
    setDecisionPhase('intro');
    setDecisionStepIndex(0);
    setDecisionAnswer(null);
    setDecisionSelectedAnswers([]);
    setDecisionDragAnswer([]);
  }

  if (q?.type === 'generalOptionDrag' || q?.type === 'orderSelectionDrag') {
    const normalizedOptions = Array.isArray(q.options)
      ? q.options.map((value, index) => ({
          id: buildGeneralOptionId(index),
          value,
          label: String(value),
        }))
      : [];

    const shuffled = shuffleArray(normalizedOptions);
    setShuffledGeneralDragOptions(shuffled);

    if (q.type === 'orderSelectionDrag') {
      // Pre-fill all slots with shuffled options — user rearranges
      setGeneralDragAnswer(shuffled.map((o) => o.id));
      setDesableButton(false);
      setTextButton('Verifica');
      setChangeColorButton(true);
      setOrderSelectedSlotIndex(null);
    } else {
      const slotsCount = getDecisionDragSlotsCount(q);
      setGeneralDragAnswer(Array(slotsCount).fill(null));
    }
    setSelectedDecisionDragOptionId(null);
  }
}, [nextQuestion, lessonData]);



// 🔥 Resetăm viețile DOAR la începutul lecției, NU la fiecare update
useEffect(() => {
  if (nextQuestion === 0) {
    setLives(3);

    // 🔁 reset statistici pe lecție
    setLessonCoins(0);
    setLessonXp(0);
    setCorrectAnswersCount(0);
    setWrongAnswersCount(0);
  }
}, [nextQuestion]);

const isJumpHereLesson =
  (lessonDataFromState?.explanationType || lessonData?.explanationType || '')
    .toLowerCase() === 'jumphere';

useEffect(() => {
  if (isJumpHereLesson) {
    setShowJumpHereIntro(true);
    return;
  }

  setShowJumpHereIntro(false);
}, [isJumpHereLesson, chapterId, lessonId]);





useEffect(() => {
  const question = lessonData?.questions?.[nextQuestion];

  if (question?.type === 'dragAndDropHorizontal') {
    const slotsCount = getHorizontalDragSlotsCount(question);
    setDataReceived(Array(slotsCount).fill(null));
  }
}, [lessonData, nextQuestion]);








useEffect(() => {
  if (lives <= 0) {
    setShowNoLivesPopup(true);
  }
}, [lives]);



useEffect(() => {
  if (!userId) return;

  fetch(`${apiUrl}/user/${userId}/stats`, {
    method: "GET",
    credentials: "include",
  })
    .then(res => res.json())
    .then(data => {
      setXp(data.xp || 0);
    })
    .catch(err => console.error("Eroare la preluarea XP:", err));
}, [userId]);


const addXp = async (amount) => {
  try {
    const res = await fetch(`${apiUrl}/stats/add-xp`, {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ xp: amount }),
    });

    if (!res.ok) throw new Error("Eroare la adăugarea XP");

    const data = await res.json();
    setXp(data.xp); // actualizezi XP din backend
  } catch (err) {
    console.error("Eroare update XP:", err);
  }
};


const addCoins = async (amount) => {
  try {
    const res = await fetch(`${apiUrl}/stats/add-coins`, {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ coins: amount }),
    });

    const data = await res.json();

    // 🔥 Actualizezi monedele și în UI
    setCoinCount(data.coins);

  } catch (err) {
    console.error("Eroare update coins:", err);
  }
};


const updateDailyMissions = async ({ xp = 0, lesson = 0, application = 0, coins = 0 }) => {
  try {
    await fetch(`${apiUrl}/missions/update`, {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        xp,
        lesson,
        application,
        coins
      })
    });
  } catch (err) {
    console.error("Eroare update misiuni:", err);
  }
};


const sendLessonFinishXp = async (amount) => {
  try {
    const res = await fetch(`${apiUrl}/stats/lesson-finished`, {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ xp: amount }),
    });

    const data = await res.json();
    setXp(data.xp);
  } catch (err) {
    console.error("Eroare la trimiterea XP final:", err);
  }
};



const grantXpForCorrectAnswer = () => {
  setCorrectStreak(prev => {
    const next = prev + 1;

    if (next === 5) {
      addXp(20);
      setLessonXp(prevXp => prevXp + 20);

      updateDailyMissions({ xp: 20 }); // 🔥 adaugă asta
    } else {
      addXp(10);
      setLessonXp(prevXp => prevXp + 10);

      updateDailyMissions({ xp: 10 }); // 🔥 adaugă asta
    }

    setCorrectAnswersCount(prevCorrect => prevCorrect + 1);

    return next;
  });
};


const handleXpResetOnWrongAnswer = () => {
  setCorrectStreak(0);
  setWrongAnswersCount(prev => prev + 1);
};


const handleCorrectCoins = () => {
  setCoinCount(prev => prev + 1);
  setLessonCoins(prev => prev + 1);

  updateDailyMissions({ coins: 1 }); // 🔥 adaugă asta
};



useEffect(() => {
  const currentQuestion = lessonData?.questions?.[nextQuestion];

  if (!currentQuestion) return;

  if (currentQuestion.type !== "lessonResume") {
    setShowRatingSection(false);
    return;
  }

  if (!currentQuestion.descriptionExplanation) return;

  // fiecare linie apare la 0.3s → totalul este:
  const delay = currentQuestion.descriptionExplanation.length * 300 + 400;

  const timer = setTimeout(() => {
    setShowRatingSection(true);
  }, delay);

  return () => clearTimeout(timer);
}, [lessonData, nextQuestion]);




useEffect(() => {
  if (showRatingSection) {
    const el = document.querySelector('.explanation-lesoon-container-resume-bc');

    if (el) {
      el.classList.add('no-scroll-transition');

      setTimeout(() => {
        el.classList.remove('no-scroll-transition');
      }, 600); // puțin peste durata animatiei
    }
  }
}, [showRatingSection]);




  useEffect(() => {
  const handleBeforeUnload = (event) => {
    event.preventDefault();
    event.returnValue = '';
  };

  window.addEventListener('beforeunload', handleBeforeUnload);

  return () => {
    window.removeEventListener('beforeunload', handleBeforeUnload);
  };
}, []);



const noTransitionTypes = [ 
  'lessonResume',
  'JustInTimeMotivation',
  'serieCompleta',
  'deblocarePremium',
  'clasament',
  'lessonCompletion',
  'giftlesson'
];




useEffect(() => {
  document.documentElement.classList.add("quiz-active");
  document.body.classList.add("quiz-active");

  return () => {
    document.documentElement.classList.remove("quiz-active");
    document.body.classList.remove("quiz-active");
  };
}, []);



  const [hideActionButton, setHideActionButton] = useState(false);

const [showComments, setShowComments] = useState(false);



const [showExplanationPopupModal, setShowExplanationPopupModal] = useState(false);




const sendLessonCompletion = async (questionType) => {
  if (questionType !== 'lessonCompletion') {
    return;
  }

  const normalizedChapterId = Number(chapterId);
  const normalizedLessonId = Number(lessonId);

  if (!Number.isFinite(normalizedChapterId) || !Number.isFinite(normalizedLessonId)) {
    console.error('❌ ID-uri invalide pentru lesson completion:', { chapterId, lessonId });
    return;
  }

  try {
    const response = await fetch(`${apiUrl}/lesson/complete`, {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        chapterId: normalizedChapterId,
        lessonId: normalizedLessonId
      })
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(errorText || `HTTP ${response.status}`);
    }

    console.log("✅ Lesson completion trimisa");
  } catch (err) {
    console.error("❌ Eroare lesson completion:", err);
  }
};


  
  
  const [showFeedback, setShowFeedback] = useState(false);

const handleShowFeedback = () => setShowFeedback(true);
const handleHideFeedback = () => setShowFeedback(false);


  const explanationRef = useRef(null);




const updateCoins = (newAmount) => {
  fetch(`${apiUrl}/user/${userId}/stats`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({
      coins: newAmount
    })
  })
  .catch(err => console.log("Error updating coins:", err));
};








  const [showExplanationPopup, setShowExplanationPopup] = useState(false);




  const [showEyePopup, setShowEyePopup] = useState(false);

const handleShowEyePopup = () => {
  setShowEyePopup(true);
};

const closeEyePopup = () => {
  setShowEyePopup(false);
};



const [showAlert, setShowAlert] = useState(false);


const handleExitClick = () => {
  setShowAlert(true);
};

const handleConfirmExit = () => {
  setShowAlert(false);
  navigate('/functionalpagelogin'); // Redirecționează către pagina /functionalpagelogin
};

const handleCancelExit = () => {
  setShowAlert(false);
};

const messageAlertClose = 
<div>
  <h3>Nu renunța!</h3>
  <p>Dacă părăsești această lecție, vei pierde progresul. Ești sigur?</p>
</div>;








  const currentType = lessonData?.questions?.[nextQuestion]?.type;




  const [isLessonFinished, setIsLessonFinished] = useState(false); // Stare pentru finalizarea lecției


  const [changeColorButton, setChangeColorButton] = useState(false);




  //stateuri pentru raspunsul corect

  const [simpleCorrectAnswer, setSimpleCorrectAnswer] = useState(false)


const lessonCompletionSentRef = useRef(false);



  // Funcția pentru a finaliza lecția și redirecționare

  
  const finalizeLesson = () => {

    const lessonProgress = JSON.parse(localStorage.getItem('lessonProgress')) || {};
    const normalizedChapterId = Number(chapterId);
    const normalizedLessonId = Number(lessonId);
    const currentLessonKey = `${normalizedChapterId}-${normalizedLessonId}`;

    const updatedProgress = {
      [currentLessonKey]: {
        ...(lessonProgress[currentLessonKey] || {}),
        completed: true,
        unlocked: true,
      },
    };

    // Salvează progresul actualizat în localStorage
    localStorage.setItem(
      'lessonProgress',
      JSON.stringify({
        ...lessonProgress,
        ...updatedProgress,
      })
    );
    addXp(20);


    // Navighează înapoi la Showlessons și trimite progresul prin state
    navigate('/functionalpagelogin', { state: { updatedProgress } });
 // Redirecționează la LessonContainer
  };

  

//functia pentru calcularea progresului

const calculateProgress = () => {
  if (!lessonData || !lessonData.questions || lessonData.questions.length === 0) {
    return 0;
  }

  const questions = lessonData.questions;

  // 👉 doar cele care contează la progres (fără clasament, lessonResume etc.)
  const countedQuestions = questions.filter(
    q => !ignoredForProgress.includes(q.type)
  );

  // dacă nu avem întrebări „reale”, progres 0
  if (countedQuestions.length === 0) return 0;

  const currentQuestion = questions[nextQuestion];
  const nextQuestionType = questions[nextQuestion + 1]?.type;
  const isCurrentQuestionCounted =
    currentQuestion && !ignoredForProgress.includes(currentQuestion.type);

  const isDecisionFlowInProgress =
    currentQuestion?.type === 'decisionFlowApplication' &&
    decisionPhase !== 'final';

  const shouldPreviewCompletionProgress =
    !isDecisionFlowInProgress && (
      pendingLessonCompletionAdvance || (
      nextQuestionType === 'lessonCompletion' ||
      nextQuestionType === 'giftlesson' ||
      nextQuestion + 1 >= questions.length
    ) &&
    (isAnswerChecked || !isCurrentQuestionCounted)
  );

  const effectiveQuestionIndex = shouldPreviewCompletionProgress
    ? nextQuestion + 1
    : nextQuestion;

  // câte întrebări „reale” ai trecut până la indexul efectiv
  const doneCount = questions
    .slice(0, effectiveQuestionIndex)
    .filter(q => !ignoredForProgress.includes(q.type))
    .length;

  const totalCount = countedQuestions.length;
  const progress = (doneCount / totalCount) * 100;

  return Math.min(progress, 100);
};








  //state pentru setarea mesajului

    // State pentru a stoca răspunsurile mutate
    const [dataReceived, setDataReceived] = useState([]);
    const [isTopProgressReady, setIsTopProgressReady] = useState(true);
    const [pendingLessonCompletionAdvance, setPendingLessonCompletionAdvance] = useState(false);
    const [shouldDelayLessonCompletionAdvance, setShouldDelayLessonCompletionAdvance] = useState(false);
    const lessonCompletionDelayTimeoutRef = useRef(null);

 


     
 


const advanceQuestion = () => {
  resetQuestionState();

  setNextQuestion((prev) => {
    const newNextQuestion = prev + 1;

    // Dacă am ajuns la ultima întrebare → marchează lecția ca finalizată
    if (newNextQuestion >= lessonData.questions.length) {
      setIsLessonFinished(true);
      // finalMessage will be set with delay in useEffect
      return prev; // ✅ rămâne pe ultima întrebare, nu trece peste array
    }

    return newNextQuestion;
  });
};

const toNextQuestion = () => {
  if (pendingLessonCompletionAdvance) {
    return;
  }

  if (!noTransitionTypes.includes(currentType) && !isTopProgressReady) {
    return;
  }

  const nextQuestionType = lessonData?.questions?.[nextQuestion + 1]?.type;
  const shouldWaitForCompletionBar =
    nextQuestionType === 'lessonCompletion' ||
    nextQuestionType === 'giftlesson';

  if (shouldWaitForCompletionBar && !pendingLessonCompletionAdvance) {
    setIsTopProgressReady(true);
    setShouldDelayLessonCompletionAdvance(false);
    setPendingLessonCompletionAdvance(false);
    advanceQuestion();
    return;
  }

  advanceQuestion();
};

useEffect(() => {
  if (!pendingLessonCompletionAdvance || !isTopProgressReady) {
    return;
  }

  if (shouldDelayLessonCompletionAdvance) {
    if (lessonCompletionDelayTimeoutRef.current) {
      clearTimeout(lessonCompletionDelayTimeoutRef.current);
    }

    lessonCompletionDelayTimeoutRef.current = setTimeout(() => {
      setPendingLessonCompletionAdvance(false);
      setShouldDelayLessonCompletionAdvance(false);
      advanceQuestion();
      lessonCompletionDelayTimeoutRef.current = null;
    }, 0);

    return;
  }

  setPendingLessonCompletionAdvance(false);
  setShouldDelayLessonCompletionAdvance(false);
  advanceQuestion();
}, [pendingLessonCompletionAdvance, isTopProgressReady, shouldDelayLessonCompletionAdvance]);

useEffect(() => {
  if (!pendingLessonCompletionAdvance || isTopProgressReady) {
    return;
  }

  const fallbackTimer = setTimeout(() => {
    setIsTopProgressReady(true);
  }, 700);

  return () => clearTimeout(fallbackTimer);
}, [pendingLessonCompletionAdvance, isTopProgressReady]);

useEffect(() => {
  return () => {
    if (lessonCompletionDelayTimeoutRef.current) {
      clearTimeout(lessonCompletionDelayTimeoutRef.current);
    }
  };
}, []);




useEffect(() => {
  if (!lessonData) return;

  const question = lessonData.questions[nextQuestion];

  if (!question) return;

  // 🔥 reset total pentru drag & drop
  if (question.type === 'dragAndDropHorizontal') {
    const slotsCount = getHorizontalDragSlotsCount(question);
    setDataReceived(Array(slotsCount).fill(null));
  }

  if (question.type === 'dragAndDropOneAnswer') {
    setDataReceived([]); // 🔥 FOARTE IMPORTANT
  }

  if (question.type === 'optionDragAndDropFormulaLeft') {
    const slotsCount = Array.isArray(question.correctAnswer) && question.correctAnswer.length > 0
      ? question.correctAnswer.length
      : 8;
    setDataReceived(Array(slotsCount).fill(null));
  }

  if (question.type === 'optionDragAndDropFormulaRight') {
    const slotsCount = Array.isArray(question.correctAnswer) && question.correctAnswer.length > 0
      ? question.correctAnswer.length
      : 8;
    setDataReceived(Array(slotsCount).fill(null));
  }
}, [nextQuestion, lessonData]);



useEffect(() => {
  if (explanationRef.current) {
    explanationRef.current.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  } else {
    // fallback pentru tot documentul dacă nu ai explanationRef în pagină
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
}, [nextQuestion]);




  useEffect(() => {
    if (chapterId && lessonId) {
      // Cererea fetch pentru lecția selectată
      fetch(`${apiUrl}/chapter/${chapterId}/lesson/${lessonId}`, {
        method: 'GET',
        headers: {
          "Content-Type": "application/json",
          "Cache-Control": "no-cache"
        }
      })
      .then((response) => {
        if (!response.ok) {
          throw new Error('A apărut o eroare');
        }
        return response.json();
      })
      .then(data => {
        setLessonData(data);
      })
      .catch(err => {
        console.error(`Error: ${err}`);
      });
    }
  }, [chapterId, lessonId]);


// Folosim un string (sau null) pentru simpleSelectType, deoarece utilizatorul selectează o singură opțiune
const [simpleSelectType, setSimpleSelectType] = useState(null); //usestateul pentru stocarea raspusurilor simple select
const [userInput, setUserInput] = useState({});  // Răspunsul introdus de utilizator
const [selectedAnswers, setSelectedAnswers] = useState([]); // Răspunsurile bifate de utilizator
const [message, setMessage] = useState('');
const [textButton, setTextButton] = useState('')

useEffect(() => {
  setTextButton('Continua');
}, [isLessonFinished, lessonData, nextQuestion]);


const [isAnswerChecked, setIsAnswerChecked] = useState(false); //urmaresc daca raspunsul a fost verificat


const buttonTextChange = () => {

  if (!lessonData || !lessonData.questions || lessonData.questions.length === 0) {
    return <p>Loading lesson...</p>;
  }
  const currentQuestion = lessonData.questions[nextQuestion]; 

  switch (currentQuestion.type) {
 

    case 'simpleSelect':
      setTextButton('Verifica')
      setChangeColorButton(true)
      break;

    case 'manualInput':
      
      break;

 

      case 'dragAndDropHorizontal':
        setTextButton('Verifica');
       
        
        break;

        case 'dragAndDropOneAnswer':
          setTextButton('Verifica');
         
          
          break;

        case 'orderSelectionDrag':
        case 'generalOptionDrag':
          setTextButton('Verifica');
          break;


    case 'multipleSelect':
      setTextButton('Verifica')
     
      break;

    default:
      
  }
};


const [desableButon, setDesableButton] = useState(false);
//functia pentru dezactivarea butonului






useEffect(() => {
  if (!lessonData || !lessonData.questions || lessonData.questions.length === 0) {
      return;
  }

  const currentQuestion = lessonData.questions[nextQuestion];

  // Resetare stări pentru fiecare nouă întrebare
  setIsAnswerChecked(false);
  setSimpleSelectType(null);
  setMessage('');
  setSimpleCorrectAnswer(false);  // Ascunde răspunsul corect

  // Dacă tipul întrebării necesită selecție, dezactivează butonul
  if (['simpleSelect', 'manualInput', 'dragAndDropHorizontal', 'dragAndDropOneAnswer', 'multipleSelect', 'generalOptionDrag', 'trueFalseQuiz'].includes(currentQuestion.type)) {
      setDesableButton(true);
  } else {
      // Activați butonul pentru explanationLesson și lessonResume
      setDesableButton(false);
  }
}, [nextQuestion, lessonData]);


const [answerStatus, setAnswerStatus] = useState(null); // Starea pentru corect/greșit/null


const resetQuestionState = () => {
  setSelectedAnswers([]);
  setSimpleSelectType(null);
  setUserInput({});
  setIsAnswerChecked(false);
  setSimpleCorrectAnswer(false);
  setAnswerStatus(null);
  setMessage('');
  setTextButton('');
  setChangeColorButton(false);
  setDesableButton(true);
  setShowCorrectAnswer(false);
};












// Adăugăm o stare pentru a controla afișarea răspunsului corect
const [showCorrectAnswer, setShowCorrectAnswer] = useState(false);




  //functia de verificare a raspunsurilor
  
  const verifyAnswer = () => {

       if (!lessonData || !lessonData.questions || lessonData.questions.length === 0) {
      return <p>Loading lesson...</p>;
    }
    const currentQuestion = lessonData.questions[nextQuestion]; 


    switch (currentQuestion.type) {
 

      case 'trueFalseQuiz':
          if (!isAnswerChecked) {
              if (currentQuestion.correctAnswer === simpleSelectType) {
                  setAnswerStatus('correct');
                  const audioUp = new Audio(levelUp);
                  audioUp.play();
                  handleCorrectCoins();
                  grantXpForCorrectAnswer();
                  triggerVibration(200);
              } else {
                  setAnswerStatus('incorrect');
                  setLives(prev => prev - 1);
                  handleXpResetOnWrongAnswer();
                  const audioErr = new Audio(error);
                  audioErr.play();
                  setSimpleCorrectAnswer(currentQuestion.correctAnswer);
                  triggerVibration([300, 100, 300]);
              }
              setIsAnswerChecked(true);
              setDesableButton(false);
              setChangeColorButton(false);
          } else {
              setIsAnswerChecked(false);
              setSimpleSelectType(null);
              setMessage('');
              toNextQuestion();
          }
          break;

      case 'simpleSelect':
          if (!isAnswerChecked) {
              setDesableButton(true); // Dezactivați butonul la începutul întrebării
              if (currentQuestion.correctAnswer === simpleSelectType) {
                setMessage(''); // Folosește numele real al array-ului

                  setAnswerStatus('correct');
                  const audioUp = new Audio(levelUp);
                  audioUp.play();
                  handleCorrectCoins();

                 // -------- XP ----------
                 grantXpForCorrectAnswer();




                  triggerVibration(200);
                  setDesableButton(false); // Activează butonul după verificarea răspunsului
              } else {
                  setMessage(''); 
                  setAnswerStatus('incorrect');
                  // 🔥 Scadem o viață când răspunsul este greșit
setLives(prev => prev - 1);
handleXpResetOnWrongAnswer();





                  const audioErr = new Audio(error);
                  audioErr.play();
                  setSimpleCorrectAnswer(currentQuestion.correctAnswer);
                  triggerVibration([300, 100, 300]);
                  setDesableButton(false);
              }
              setIsAnswerChecked(true);
             
              setShowCorrectAnswer(false);
              setChangeColorButton(false);
          } else {
              // Trecem la următoarea întrebare
              setIsAnswerChecked(false);
              setSimpleSelectType(null);
              setMessage('');
              
              toNextQuestion();
              setShowCorrectAnswer(false);
          }
          break;
      case 'manualInput':
        if (!isAnswerChecked) {
          // Verificăm dacă toate răspunsurile sunt corecte
          let allCorrect = true;
          currentQuestion.correctAnswer.forEach((answer, index) => {
            // Comparam răspunsul utilizatorului cu codul corect
            if (Number(userInput[index]) !== answer.code) {
              allCorrect = false;
            }
          });
          if (allCorrect) {
           setMessage('');
            setAnswerStatus('correct');
            const audioUp = new Audio(levelUp);
                audioUp.play();
            setSimpleCorrectAnswer(false);
            handleCorrectCoins();

                 grantXpForCorrectAnswer();



            // Vibrație scurtă pentru răspuns corect
          triggerVibration(200); // 200ms pentru un răspuns corect
          } else {
            setMessage('');

            setAnswerStatus('incorrect');
            // 🔥 Scadem o viață când răspunsul este greșit
setLives(prev => prev - 1);
handleXpResetOnWrongAnswer();





            const audioErr = new Audio(error);
            audioErr.play();
            setSimpleCorrectAnswer(currentQuestion.correctAnswer.map((newAnswer) => {
             return <div>{newAnswer.code}:{newAnswer.label}</div>
            }));
            triggerVibration([300, 100, 300]);
          }
          setIsAnswerChecked(true);  // Marchez răspunsul ca verificat
          setChangeColorButton(false)
          setDesableButton(false); // Activăm butonul după verificare pentru a permite utilizatorului să continue
        } else {
          // A doua fază: Trecem la următoarea întrebare
          setIsAnswerChecked(false);  // Resetează starea de verificare
          setUserInput({});  // Resetează input-urile utilizatorului
          setMessage('');  // Resetează mesajul
          setChangeColorButton(false);
          toNextQuestion();  // Trecem la următoarea întrebare
        }
        break;
   

case 'simpleApplication':
  if (!isAnswerChecked) {
    if (currentQuestion.correctAnswer === simpleSelectType) {
      setAnswerStatus('correct');
      const audioUp = new Audio(levelUp);
      audioUp.play();
      handleCorrectCoins();

                grantXpForCorrectAnswer();



      triggerVibration(200);
    } else {
      setAnswerStatus('incorrect');
      // 🔥 Scadem o viață când răspunsul este greșit
setLives(prev => prev - 1);
handleXpResetOnWrongAnswer();





      const audioErr = new Audio(error);
      audioErr.play();
      setSimpleCorrectAnswer(currentQuestion.correctAnswer);
      triggerVibration([300, 100, 300]);
    }

    setIsAnswerChecked(true);
    setChangeColorButton(false);
  } else {
    setIsAnswerChecked(false);
    setSimpleSelectType(null);
    setMessage('');
    toNextQuestion();
  }
  break;


case 'decisionFlowApplication': {
  const step = currentQuestion.steps[decisionStepIndex];
  const optionType =
    step.optionType ||
    step.stepType ||
    (typeof step.type === 'string' && step.type.startsWith('option') ? step.type : 'simpleOption'); // Accepta si step.type
  const isMultiple = optionType === 'multipleOption';
  const isFormulaLayout =
    optionType === 'optionDragAndDropFormula' ||
    optionType === 'optionDragAndDropFormulaLeft' ||
    optionType === 'optionDragAndDropFormulaRight';
  const isTaccountLayout = optionType === 'optionDragTaccount';
  const isDragAndDrop = optionType === 'optionDragAndDrop' || isFormulaLayout || isTaccountLayout;

  let isCorrect = false;

  if (isDragAndDrop) {
    const expectedAnswers = Array.isArray(step.correctAnswer) ? step.correctAnswer : [];
    const selectedValues = decisionDragAnswer.map((optionId) => getDecisionOptionValueById(step, optionId));
    
    // Verifica numai slot-urile cu expected answer !== null
    isCorrect = selectedValues.every((value, idx) => {
      const expected = expectedAnswers[idx];
      
      // Ignora complet slot-urile cu expected = null/undefined/empty
      if (expected === null || expected === undefined || expected === '') {
        return true;
      }
      
      // Pentru slot-urile cu expected values, verifica exact
      return value === expected;
    });
  } else if (isMultiple) {
    // Pentru multipleOption verificam daca array-urile sunt egale
    if (Array.isArray(step.correctAnswer)) {
      const sortedCorrect = [...step.correctAnswer].sort();
      const sortedSelected = [...decisionSelectedAnswers].sort();
      isCorrect = JSON.stringify(sortedCorrect) === JSON.stringify(sortedSelected);
    }
  } else {
    // Pentru simpleOption verificam daca raspunsurile sunt egale
    isCorrect = decisionAnswer === step.correctAnswer;
  }

  if (isCorrect) {
    setAnswerStatus('correct');
    handleCorrectCoins();
    grantXpForCorrectAnswer();
    new Audio(levelUp).play();
    triggerVibration(200);
  } else {
    setAnswerStatus('incorrect');
    setLives(prev => prev - 1);
    handleXpResetOnWrongAnswer();
    new Audio(error).play();
    triggerVibration([300, 100, 300]);
  }

  setIsAnswerChecked(true);
  break;
}





case 'dragAndDropHorizontal': {
  if (!isAnswerChecked) {
    const expected = getHorizontalDragExpectedAnswers(currentQuestion).map((item) => String(item));
    const selectedValues = dataReceived.map((optionId) => getHorizontalOptionValueById(currentQuestion, optionId));

    const allSlotsFilled =
      selectedValues.length === expected.length &&
      selectedValues.every((value) => value !== null && value !== undefined && value !== '');

    const isCorrect = allSlotsFilled &&
      selectedValues.every((value, index) => String(value) === expected[index]);

    if (isCorrect) {
      setAnswerStatus('correct');
      handleCorrectCoins();
      grantXpForCorrectAnswer();
      new Audio(levelUp).play();
      triggerVibration(200);
    } else {
      setAnswerStatus('incorrect');
      setLives(prev => prev - 1);
      handleXpResetOnWrongAnswer();
      setSimpleCorrectAnswer(expected);
      new Audio(error).play();
      triggerVibration([300, 100, 300]);
    }

    setIsAnswerChecked(true);
    setChangeColorButton(false);
  } else {
    const slotsCount = getHorizontalDragSlotsCount(currentQuestion);
    setDataReceived(Array(slotsCount).fill(null));
    setIsAnswerChecked(false);
    setChangeColorButton(false);
    toNextQuestion();
  }
  break;
}

    case 'dragAndDropOneAnswer':
  if (!isAnswerChecked) {
    const userAnswer = dataReceived[0];
    const correctAnswer = currentQuestion.correctAnswer[1]; 
    

    if (userAnswer === correctAnswer) {
      setMessage('');
      setTextButton('Verifica');
      const audioUp = new Audio(levelUp);
      audioUp.play();
     handleCorrectCoins();

             grantXpForCorrectAnswer();



      triggerVibration(200);
      setAnswerStatus('correct');
      setSimpleCorrectAnswer(false);
    } else {
      setMessage('');
      setTextButton('Verifica');
      const audioErr = new Audio(error);
      audioErr.play();
      setSimpleCorrectAnswer(<div>{correctAnswer}</div>);
      triggerVibration([300, 100, 300]);
      setAnswerStatus('incorrect');
      // 🔥 Scadem o viață când răspunsul este greșit
setLives(prev => prev - 1);
handleXpResetOnWrongAnswer();





    }

    setIsAnswerChecked(true);
    setChangeColorButton(false);
  } else {
    // când trecem la întrebarea următoare
    setIsAnswerChecked(false);
    setDataReceived([]); // un singur element, deci reset total
    setMessage('');
    setTextButton('Verifica');
    setChangeColorButton(true); // ✅ să redevină colorat pentru starea de verificare
    toNextQuestion();
  }
  break;




        
      case 'orderSelectionDrag':
        case 'generalOptionDrag': {
        if (!isAnswerChecked) {
          const expectedAnswers = Array.isArray(currentQuestion.correctAnswer)
            ? currentQuestion.correctAnswer
            : [];
          const selectedValues = generalDragAnswer.map((optionId) =>
            getGeneralOptionValueById(currentQuestion, optionId)
          );

          const allSlotsFilled = selectedValues.length === expectedAnswers.length &&
            selectedValues.every((value) => value !== null && value !== undefined && value !== '');

          const isCorrect = allSlotsFilled &&
            selectedValues.every((value, idx) => value === expectedAnswers[idx]);

          if (isCorrect) {
            setMessage('');
            setAnswerStatus('correct');
            handleCorrectCoins();
            grantXpForCorrectAnswer();
            new Audio(levelUp).play();
            triggerVibration(200);
          } else {
            setMessage('');
            setAnswerStatus('incorrect');
            setLives(prev => prev - 1);
            handleXpResetOnWrongAnswer();
            new Audio(error).play();
            triggerVibration([300, 100, 300]);
          }

          setIsAnswerChecked(true);
          setChangeColorButton(false);
        } else {
          setIsAnswerChecked(false);
          const slotsCount = getDecisionDragSlotsCount(currentQuestion);
          setGeneralDragAnswer(Array(slotsCount).fill(null));
          setMessage('');
          setTextButton('Verifica');
          setChangeColorButton(true);
          toNextQuestion();
        }
        break;
      }

      case 'multipleSelect':
        if (!isAnswerChecked) {
          // Verificăm dacă răspunsurile selectate de utilizator sunt corecte
          const sortedSelected = [...selectedAnswers].sort();  // Sortăm o copie pentru comparație
          const sortedCorrect = [...currentQuestion.correctAnswer].sort();  // Sortăm răspunsurile corecte
          
          if (JSON.stringify(sortedSelected) === JSON.stringify(sortedCorrect)) {
           setMessage('');
            setAnswerStatus('correct');
            const audioUp = new Audio(levelUp);
                audioUp.play();
            setSimpleCorrectAnswer(false);
           handleCorrectCoins();

             grantXpForCorrectAnswer();


            triggerVibration(200);
          } else {
            setMessage('');
            setAnswerStatus('incorrect');
            // 🔥 Scadem o viață când răspunsul este greșit
setLives(prev => prev - 1);
handleXpResetOnWrongAnswer();





            const audioErr = new Audio(error);
                audioErr.play();
            setSimpleCorrectAnswer(currentQuestion.correctAnswer);
            triggerVibration([300, 100, 300]);
          }
          setIsAnswerChecked(true);  // Marchez răspunsul ca verificat
        
          setChangeColorButton(false);
        } else {
          // A doua fază: Trecem la următoarea întrebare
          setIsAnswerChecked(false);  // Resetează starea de verificare
          setSelectedAnswers([]);  // Resetează răspunsurile selectate
          setMessage('');  // Resetează mesajul
      
          setChangeColorButton(false);
          toNextQuestion();  // Trecem la următoarea întrebare
        }
        break;

        case 'optionDragAndDropFormulaLeft': {
          if (!isAnswerChecked) {
            const expectedAnswers = Array.isArray(currentQuestion.correctAnswer)
              ? currentQuestion.correctAnswer.map((item) => String(item))
              : [];
            const userAnswers = Array.isArray(dataReceived)
              ? dataReceived.map((item) => (item === null || item === undefined ? '' : String(item)))
              : [];

            const isCorrect = userAnswers.length === expectedAnswers.length &&
              expectedAnswers.every((val, idx) => userAnswers[idx] === val);

            if (isCorrect) {
              setMessage('');
              setAnswerStatus('correct');
              handleCorrectCoins();
              grantXpForCorrectAnswer();
              new Audio(levelUp).play();
              triggerVibration(200);
            } else {
              setMessage('');
              setAnswerStatus('incorrect');
              setLives(prev => prev - 1);
              handleXpResetOnWrongAnswer();
              new Audio(error).play();
              triggerVibration([300, 100, 300]);
            }

            setIsAnswerChecked(true);
            setChangeColorButton(false);
          } else {
            setIsAnswerChecked(false);
            const slotsCount = Array.isArray(currentQuestion.correctAnswer)
              ? currentQuestion.correctAnswer.length
              : 8;
            setDataReceived(Array(slotsCount).fill(null));
            setMessage('');
            setTextButton('Verifica');
            setChangeColorButton(true);
            toNextQuestion();
          }
          break;
        }

        case 'optionDragAndDropFormulaRight': {
          if (!isAnswerChecked) {
            const expectedAnswers = Array.isArray(currentQuestion.correctAnswer)
              ? currentQuestion.correctAnswer.map((item) => String(item))
              : [];
            const userAnswers = Array.isArray(dataReceived)
              ? dataReceived.map((item) => (item === null || item === undefined ? '' : String(item)))
              : [];

            const isCorrect = userAnswers.length === expectedAnswers.length &&
              expectedAnswers.every((val, idx) => userAnswers[idx] === val);

            if (isCorrect) {
              setMessage('');
              setAnswerStatus('correct');
              handleCorrectCoins();
              grantXpForCorrectAnswer();
              new Audio(levelUp).play();
              triggerVibration(200);
            } else {
              setMessage('');
              setAnswerStatus('incorrect');
              setLives(prev => prev - 1);
              handleXpResetOnWrongAnswer();
              new Audio(error).play();
              triggerVibration([300, 100, 300]);
            }

            setIsAnswerChecked(true);
            setChangeColorButton(false);
          } else {
            setIsAnswerChecked(false);
            const slotsCount = Array.isArray(currentQuestion.correctAnswer)
              ? currentQuestion.correctAnswer.length
              : 8;
            setDataReceived(Array(slotsCount).fill(null));
            setMessage('');
            setTextButton('Verifica');
            setChangeColorButton(true);
            toNextQuestion();
          }
          break;
        }
        break;



      
         
          setIsLessonFinished(true)
        
        break;
      default:
       <p>'Tipul întrebării nu este recunoscut'</p> 
    }
  };
  

  const handleInputChange = (index, value) => {
    const updatedInput = {
      ...userInput,
      [index]: value  // Actualizăm răspunsul pentru fiecare index
    };
    
    setUserInput(updatedInput);

   
  
    // Verificăm dacă s-au introdus date în cel puțin un câmp de input
    const hasData = Object.values(updatedInput).some(val => val.trim() !== '');
    
    // Schimbăm textul butonului dacă există input
    if (hasData) {
      setTextButton('Verifica');
    
      setChangeColorButton(true);
    } else {
      setTextButton('Continua');
    }
  };
 



// Funcția pentru a actualiza răspunsurile selectate
const handleCheckboxChange = (option) => {
  setSelectedAnswers(prevSelected => {
    let updatedSelected;
    
    if (prevSelected.includes(option)) {
      // Dacă opțiunea este deja selectată, o eliminăm din array
      updatedSelected = prevSelected.filter(answer => answer !== option);
    } else {
      // Adăugăm opțiunea selectată
      updatedSelected = [...prevSelected, option];
    }
    
    // Verificăm dacă mai sunt opțiuni selectate
    setDesableButton(updatedSelected.length === 0); // Dezactivează butonul dacă nu e nimic selectat
    return updatedSelected; // Returnează lista actualizată de răspunsuri selectate
  });

  // După fiecare schimbare, setăm textul butonului la "Verifică"
  setTextButton('Verifica');
 
  setChangeColorButton(true);
};

const [finalMessage, setFinalMessage] = useState(false);
const [isLessonCompletionBarDone, setIsLessonCompletionBarDone] = useState(false);

useEffect(() => {
  const activeQuestionType = lessonData?.questions?.[nextQuestion]?.type;

  if (activeQuestionType === 'lessonCompletion') {
    setIsLessonCompletionBarDone(false);
  }
}, [lessonData, nextQuestion]);

useEffect(() => {
  if (isLessonFinished) {
    finalizeLesson();
  }
}, [isLessonFinished]);


const [showFinalTitle, setShowFinalTitle] = useState(false);

useEffect(() => {
  if (finalMessage) {
    setShowFinalTitle(false); // resetăm înainte
    const timer = setTimeout(() => {
      setShowFinalTitle(true);  // apare cu întârziere
    }, 2500);

    return () => clearTimeout(timer);
  }
}, [finalMessage]);


const [successBubbleText, setSuccessBubbleText] = useState('Felicitari!');
const [successBubblePhase, setSuccessBubblePhase] = useState('initial'); // 'initial' | 'transition' | 'final'

useEffect(() => {
  // Resetează textul când se finalizează lecția
  if (isLessonFinished) {
    setSuccessBubbleText('Felicitari!');
    setSuccessBubblePhase('initial');
    
    // După 1.5 secunde, schimbă textul cu animație
    const timer = setTimeout(() => {
      setSuccessBubblePhase('transition');
      
      // Schimbă textul după ce animația de ieșire s-a terminat
      setTimeout(() => {
        setSuccessBubbleText('Ai terminat cu succes lectia');
        setSuccessBubblePhase('initial'); // Reset la initial pentru a putea aplica slideInRight
      }, 600); // Timing complet cu slide-out animation (0.6s)
      
      // Schimbă la 'final' pentru a porni slideInRight
      setTimeout(() => {
        setSuccessBubblePhase('final');
      }, 610); // Puțin după ce textul s-a schimbat
    }, 1500);

    return () => clearTimeout(timer);
  }
}, [isLessonFinished]);



const areAllFieldsCompleted = useCallback(() => {
  if (!lessonData || !lessonData.questions || lessonData.questions.length === 0) {
    return false;
  }

  const currentQuestion = lessonData.questions[nextQuestion];

  if (!currentQuestion) return false;

  switch (currentQuestion.type) {
    
    case 'dragAndDropHorizontal':
      {
        const slotsCount = getHorizontalDragSlotsCount(currentQuestion);
        return (
          slotsCount > 0 &&
          dataReceived.length === slotsCount &&
          dataReceived.every((val) => val !== null && val !== undefined && val !== '')
        );
      }
    case 'dragAndDropOneAnswer':
      return dataReceived.length === 1 && dataReceived[0] !== null && dataReceived[0] !== undefined;
    case 'optionDragAndDropFormulaLeft': {
      const slotsCount = Array.isArray(currentQuestion.correctAnswer) ? currentQuestion.correctAnswer.length : 8;
      return dataReceived.length === slotsCount && dataReceived.every(val => val !== null && val !== undefined && val !== '');
    }
    case 'optionDragAndDropFormulaRight': {
      const slotsCount = Array.isArray(currentQuestion.correctAnswer) ? currentQuestion.correctAnswer.length : 8;
      return dataReceived.length === slotsCount && dataReceived.every(val => val !== null && val !== undefined && val !== '');
    }
    default:
      return true;
  }
  
}, [lessonData, nextQuestion, dataReceived]);


const handleFeedback = (type) => {
  if (type === 'like') {
    console.log("Utilizatorul a apreciat lecția.");
    // poți trimite către un API, localStorage etc.
  } else {
    console.log("Utilizatorul nu a fost mulțumit.");
  }

  // opțional: afișează un mesaj de mulțumire sau închide feedbackul
};








useEffect(() => {
  if (!lessonData || !lessonData.questions || lessonData.questions.length === 0) {
    return;
  }

  const currentQuestion = lessonData.questions[nextQuestion];

  switch (currentQuestion.type) {
    case 'trueFalseQuiz':
      setDesableButton(simpleSelectType === null);
      break;

    case 'simpleSelect':
      // Dezactivăm butonul dacă nu s-a selectat încă un răspuns
      setDesableButton(simpleSelectType === null);
      break;

    case 'multipleSelect':
      // Dezactivăm butonul dacă nu s-a selectat încă un răspuns
      setDesableButton(selectedAnswers.length === 0);
      break;


      case 'simpleApplication':
  setDesableButton(simpleSelectType === null);
  break;


  case 'decisionFlowApplication':
  if (decisionPhase === 'steps') {
    setDesableButton(decisionAnswer === null);
  } else {
    setDesableButton(false);
  }
  break;


    case 'manualInput':
      // Verificăm dacă toate câmpurile de input sunt completate
      const allFilled = currentQuestion.correctAnswer.every((_, idx) => {
        return userInput[idx] && userInput[idx].trim() !== '';
      });
      setDesableButton(!allFilled);
      break;



      case 'dragAndDropHorizontal':
      // Verificăm dacă toate elementele au fost mutate corect
      setDesableButton(!areAllFieldsCompleted());
      break;
case 'dragAndDropOneAnswer': {
  const isSelected = dataReceived.length === 1 && dataReceived[0] !== null && dataReceived[0] !== undefined;
  setDesableButton(!isSelected);
  break;
}

    case 'orderSelectionDrag':
        case 'generalOptionDrag': {
      const allFilled = Array.isArray(generalDragAnswer) && generalDragAnswer.every(
        (value) => value !== null && value !== undefined && value !== ''
      );
      setDesableButton(!allFilled);
      break;
    }

    case 'optionDragAndDropFormulaLeft': {
      const slotsCount = Array.isArray(currentQuestion.correctAnswer) ? currentQuestion.correctAnswer.length : 8;
      const allFilled =
        slotsCount > 0 &&
        dataReceived.length === slotsCount &&
        dataReceived.every((v) => v !== null && v !== undefined && v !== '');
      setDesableButton(!allFilled);
      break;
    }

    case 'optionDragAndDropFormulaRight': {
      const slotsCount = Array.isArray(currentQuestion.correctAnswer) ? currentQuestion.correctAnswer.length : 8;
      const allFilled =
        slotsCount > 0 &&
        dataReceived.length === slotsCount &&
        dataReceived.every((v) => v !== null && v !== undefined && v !== '');
      setDesableButton(!allFilled);
      break;
    }

    default:
      // Activăm butonul pentru explanationLesson și lessonResume
      setDesableButton(false);
      break;
  }
}, [simpleSelectType, selectedAnswers, userInput, dataReceived, nextQuestion, lessonData, areAllFieldsCompleted]);








const renderContent = () => {
  // dacă am trecut de ultima întrebare, nu mai randăm conținut de întrebare
  if (!lessonData || !lessonData.questions) return null;
  if (nextQuestion >= lessonData.questions.length) return null;

  if (isLessonFinished && finalMessage) {
    return null; // ascunde conținutul lecției când e final
  }

  const currentQuestion = lessonData.questions[nextQuestion];

  
   
    switch (currentQuestion.type) {

    case 'explanationLesson':
      return (
        <div className="quiz-content-scroll-bc">
          <div ref={explanationRef}>
            <div className="description-lesson-text-explanation-bc">
              {/* Show card-dots only if more than one paragraph */}
              {currentQuestion?.type === 'explanationLesson' &&
                Array.isArray(currentQuestion.descriptionExplanation) &&
                currentQuestion.descriptionExplanation.length > 1 && (
                  <div className="card-dots">
                    {currentQuestion.descriptionExplanation.map((_, i) => (
                      <span
                        key={i}
                        className={`dot ${i === cardIndex ? 'active' : ''}`}
                        onClick={() => updateCardIndexWithSwipe(i)}
                      />
                    ))}
                  </div>
                )}

              {/* CARDURI CONTROLATE */}
              <div className="card-stack-container">
                {currentQuestion.descriptionExplanation.map((explanation, index) => {
                  const totalCards = currentQuestion.descriptionExplanation.length;
                  const offset = (index - cardIndex + totalCards) % totalCards;
                  const isLeavingCard = index === leavingCardIndex;

                  // 🔥 cardul curent + următorul (circular) + cardul care iese spre dreapta
                  if (offset > 1 && !isLeavingCard) return null;

                  const cardStateClass = isLeavingCard
                    ? 'leaving'
                    : offset === 0
                    ? 'active'
                    : 'next';

                  return (
                    <div
                      key={index}
                      className={`explanation-card-bc ${cardStateClass}`}
                      style={{
                        transform:
                          isLeavingCard
                            ? 'translateX(120%) rotate(7deg) scale(0.93)'
                            : offset === 0
                            ? 'translateY(0) scale(0.95)'
                            : 'translateY(0px) translateX(0px) scale(0.96) rotate(2deg)',
                        zIndex: isLeavingCard ? 12 : 10 - offset,
                        opacity: isLeavingCard ? 0 : offset === 0 ? 1 : 0.5
                      }}
                    >
                      <div
                        className="text-size-emplanation-bc"
                        dangerouslySetInnerHTML={{ __html: explanation }}
                      />
                    </div>
                  );
                })}
              </div>

              {/* IMAGINE doar sub ultimul card */}
              {currentQuestion.image && (
                <div className="lesson-image-container">
                  <img
                    src={currentQuestion.image}
                    alt="Explicatie lectie"
                    className="lesson-image"
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      );

    case 'giftlesson':
      return (
        <div className="quiz-content-scroll-bc">
          <div className="gift-lesson-container">
            <div className="gift-lesson-header">
              <h2>🎁 Felicitări! Ai primit un cadou!</h2>
            </div>
            <div className="gift-lesson-content">
              {Array.isArray(currentQuestion.giftMessages)
                ? currentQuestion.giftMessages.map((msg, idx) => (
                    <div key={idx} className="gift-message" dangerouslySetInnerHTML={{ __html: msg }} />
                  ))
                : <div className="gift-message" dangerouslySetInnerHTML={{ __html: currentQuestion.giftMessages }} />}
            </div>
            {currentQuestion.giftImage && (
              <div className="gift-lesson-image-container">
                <img
                  src={currentQuestion.giftImage}
                  alt="Gift"
                  className="gift-lesson-image"
                />
              </div>
            )}
       
          </div>
        </div>
      );


      case 'trueFalseQuiz':
        return (
          <div className="quiz-content-scroll-bc">
            <div className='explanation-lesoon-container-bc'>
              <div className='title-simple-select-align'>
                <div className="centred-simple-element">
                  <span className="question-text-bc">{currentQuestion.question}</span>
                </div>
              </div>
              <div className='true-false-buttons-bc'>
                {['Adevarat', 'Fals'].map(option => {
                  let className = 'true-false-btn-bc';
                  if (isAnswerChecked) {
                    if (option === currentQuestion.correctAnswer) {
                      className = 'true-false-btn-bc true-false-correct-bc';
                    } else if (option === simpleSelectType) {
                      className = 'true-false-btn-bc true-false-incorrect-bc';
                    }
                  } else if (simpleSelectType === option) {
                    className = 'true-false-btn-bc true-false-selected-bc';
                  }
                  return (
                    <button
                      key={option}
                      className={className}
                      disabled={isAnswerChecked}
                      onClick={() => {
                        setSimpleSelectType(option);
                        setDesableButton(false);
                        setTextButton('Verifica');
                        setChangeColorButton(true);
                      }}
                    >
                      {option === 'Adevarat'
                        ? <span>✔ Adevarat</span>
                        : <span>✘ Fals</span>
                      }
                    </button>
                  );
                })}
              </div>
            </div>
          </div>
        );

      case 'simpleSelect':
        return (
          <div className="quiz-content-scroll-bc">
          <div className='explanation-lesoon-container-bc'>
           
            <div className='tittle-sescrition-lesson title-simple-select-align'>

            <div className="centred-simple-element">
              <span className="question-text-bc">{currentQuestion.question}</span>
             
            </div>

              

            </div>
            <div className='simple-select-buttons-description-bc'>
{shuffledOptions.map(option => {
  let className = 'simple-Button-select-bc';

  if (isAnswerChecked) {
    if (option === currentQuestion.correctAnswer) {
      className = 'simple-Button-select-correct-bc';
    } else if (option === simpleSelectType) {
      className = 'simple-Button-select-incorrect-bc';
    }
  } else if (simpleSelectType === option) {
    className = 'simple-Button-select-colored-bc';
  }

  return (
    <button
      key={option}   // ✅ CHEIE STABILĂ → RANDOM OK
      className={className}
      disabled={isAnswerChecked}
      onClick={() => {
        setSimpleSelectType(option);
        buttonTextChange();
        setDesableButton(false);
      }}
    >
      <p>{option}</p>
    </button>
  );
})}


</div>


            
          </div>
          </div>
        );


case 'simpleApplication':
  return (
    <div className="quiz-content-scroll-bc">
      <div className="simple-application-container-bc">
        <div className="simple-application-instruction-bc">
          <div className="simple-application-content-bc">
            <div className="simple-application-context-bc">
              <p>{currentQuestion.context}</p>
            </div>
            <div className="simple-application-question-bc">
              <p>{currentQuestion.question}</p>
            </div>
            <div className="simple-application-buttons-bc">
              {shuffledApplicationOptions.map(option => (
                <div
                  key={option}
                  className={
                    isAnswerChecked
                      ? option === currentQuestion.correctAnswer
                        ? "simple-application-correct-bc"
                        : option === simpleSelectType
                        ? "simple-application-incorrect-bc"
                        : "simple-application-default-bc"
                      : simpleSelectType === option
                      ? "simple-application-selected-bc"
                      : "simple-application-default-bc"
                  }
                  onClick={() => {
                    if (isAnswerChecked) return;
                    setSimpleSelectType(option);
                    setDesableButton(false);
                    setTextButton("Verifica");
                    setChangeColorButton(true);
                  }}
                >
                  <b>{option}</b>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );

case 'orderSelectionDrag':
        case 'generalOptionDrag': {
  const normalizedOptions = shuffledGeneralDragOptions.length
    ? shuffledGeneralDragOptions
    : (Array.isArray(currentQuestion.options) ? currentQuestion.options : []).map((value, index) => ({
        id: buildGeneralOptionId(index),
        value,
        label: String(value),
      }));

  const slotsCount = getDecisionDragSlotsCount(currentQuestion);
  const expectedAnswers = Array.isArray(currentQuestion.correctAnswer) ? currentQuestion.correctAnswer : [];
  const rows = currentQuestion.type === 'orderSelectionDrag'
    ? Array.from({ length: slotsCount }, () => ({ label: '', slots: 1 }))
    : (Array.isArray(currentQuestion.rows) && currentQuestion.rows.length > 0
      ? currentQuestion.rows
      : [{ label: '', slots: slotsCount }]);

  const dndOnDragOver = (event) => {
    event.preventDefault();
  };

  const dndReadDraggedValue = (event) => {
    try {
      const payload = event.dataTransfer.getData('application/json');
      if (payload) {
        const parsed = JSON.parse(payload);
        if (parsed && parsed.id) return parsed.id;
      }
    } catch (err) {
      // fallback
    }
    return event.dataTransfer.getData('text/plain');
  };

  const updateGeneralDragState = (next) => {
    setGeneralDragAnswer(next);
    if (currentQuestion.type === 'orderSelectionDrag') {
      // All slots always filled — button always enabled
      setDesableButton(false);
      setTextButton('Verifica');
      setChangeColorButton(true);
      return;
    }
    const hasSelection = next.some(
      (item) => item !== null && item !== undefined && item !== ''
    );
    setDesableButton(!hasSelection);
    if (hasSelection) {
      setTextButton('Verifica');
      setChangeColorButton(true);
    }
  };

  const dndPlaceInSlot = (slotIndex, optionId) => {
    if (isAnswerChecked) return;

    const next = Array.isArray(generalDragAnswer) && generalDragAnswer.length === slotsCount
      ? [...generalDragAnswer]
      : Array(slotsCount).fill(null);

    if (currentQuestion.type === 'orderSelectionDrag') {
      // Swap: find where optionId currently is and put displaced item there
      const existingIndex = next.indexOf(optionId);
      const displaced = next[slotIndex];
      if (existingIndex !== -1) {
        next[existingIndex] = displaced;
      }
      next[slotIndex] = optionId;
    } else {
      const existingIndex = next.indexOf(optionId);
      if (existingIndex !== -1) {
        next[existingIndex] = null;
      }
      next[slotIndex] = optionId;
    }
    updateGeneralDragState(next);
  };

  const dndDropOnSlot = (event, slotIndex) => {
    event.preventDefault();
    const optionId = dndReadDraggedValue(event);
    if (!optionId) return;
    dndPlaceInSlot(slotIndex, optionId);
  };

  const dndDropOnOptions = (event) => {
    event.preventDefault();
    if (isAnswerChecked) return;

    const optionId = dndReadDraggedValue(event);
    if (!optionId) return;

    const next = (Array.isArray(generalDragAnswer) ? generalDragAnswer : Array(slotsCount).fill(null))
      .map((item) => (item === optionId ? null : item));
    updateGeneralDragState(next);
  };

  const dndSlotClick = (slotIndex) => {
    if (isAnswerChecked) return;

    if (currentQuestion.type === 'orderSelectionDrag') {
      // Tap-to-swap: first tap selects, second tap on a different slot swaps
      if (orderSelectedSlotIndex === null) {
        setOrderSelectedSlotIndex(slotIndex);
      } else if (orderSelectedSlotIndex === slotIndex) {
        setOrderSelectedSlotIndex(null); // deselect
      } else {
        const next = [...generalDragAnswer];
        const tmp = next[orderSelectedSlotIndex];
        next[orderSelectedSlotIndex] = next[slotIndex];
        next[slotIndex] = tmp;
        updateGeneralDragState(next);
        setOrderSelectedSlotIndex(null);
      }
      return;
    }

    const next = Array.isArray(generalDragAnswer) ? [...generalDragAnswer] : Array(slotsCount).fill(null);
    next[slotIndex] = null;
    updateGeneralDragState(next);
  };

  const dndOptionClick = (optionId) => {
    if (isAnswerChecked) return;

    const firstEmpty = (Array.isArray(generalDragAnswer) ? generalDragAnswer : Array(slotsCount).fill(null)).findIndex(
      (item) => item === null || item === undefined || item === ''
    );
    if (firstEmpty !== -1) {
      dndPlaceInSlot(firstEmpty, optionId);
    }
  };

  const dndDragStartOption = (event, optionId) => {
    event.dataTransfer.setData('application/json', JSON.stringify({ id: optionId }));
    event.dataTransfer.setData('text/plain', String(optionId));
  };

  let currentSlotIndex = 0;

  return (
    <div className="quiz-content-scroll-bc">
      <div className="explanation-lesoon-container-bc">
        <div className="title-simple-select-align">
          <p className="centred-simple-element">
            {currentQuestion.question}
          </p>
        </div>

        <div className="decision-dnd-container-bc">
          {rows.map((row, rowIndex) => {
            const rowSlots = Math.max(0, Number(row?.slots) || 0);
            const rowLabel = currentQuestion.type === 'orderSelectionDrag' ? '' : (row?.label ?? '');
            const startIndex = currentSlotIndex;
            currentSlotIndex += rowSlots;

            return (
              <div key={`general-dnd-row-${rowIndex}`} className="decision-dnd-row-bc">
                {rowLabel && <p className="decision-dnd-row-label-bc">{rowLabel}</p>}
                <div className="decision-dnd-row-slots-bc">
                  {Array.from({ length: rowSlots }, (_, idx) => {
                    const slotIndex = startIndex + idx;
                    const optionId = generalDragAnswer[slotIndex] ?? null;
                    const value = getGeneralOptionValueById(currentQuestion, optionId) || '';
                    const expectedValue = expectedAnswers[slotIndex] ?? '';
                    const isCorrectSlot = isAnswerChecked && value && value === expectedValue;
                    const isWrongSlot = isAnswerChecked && value && value !== expectedValue;

                    return (
                      <button
                        key={`general-dnd-slot-${slotIndex}`}
                        type="button"
                        className={`decision-dnd-slot-bc ${currentQuestion.type === 'orderSelectionDrag' ? 'order-selection-slot-bc' : ''} ${value ? 'filled' : ''} ${isCorrectSlot ? 'correct' : ''} ${isWrongSlot ? 'incorrect' : ''} ${currentQuestion.type === 'orderSelectionDrag' && orderSelectedSlotIndex === slotIndex ? 'order-selection-slot-selected-bc' : ''}`}
                        onDragOver={dndOnDragOver}
                        onDrop={(event) => dndDropOnSlot(event, slotIndex)}
                        onClick={() => dndSlotClick(slotIndex)}
                        draggable={!isAnswerChecked && Boolean(optionId)}
                        onDragStart={(event) => optionId && dndDragStartOption(event, optionId)}
                        disabled={isAnswerChecked}
                      >
                        {currentQuestion.type === 'orderSelectionDrag' ? (
                          <>
                            <span className='order-selection-index-bc'>{slotIndex + 1}</span>
                            <span className='order-selection-field-bc'>
                              {value ? (
                                <span className='decision-dnd-slot-bc-filled-style'>{value}</span>
                              ) : (
                                <span className='order-selection-empty-field-bc'>&nbsp;</span>
                              )}
                            </span>
                          </>
                        ) : (
                          <>
                            {value && <span className='decision-dnd-slot-bc-filled-style'>{value}</span>}
                          </>
                        )}
                      </button>
                    );
                  })}
                </div>
              </div>
            );
          })}
        </div>

        {!isAnswerChecked && currentQuestion.type !== 'orderSelectionDrag' && (
          <div
            className="decision-dnd-options-bc"
            onDragOver={dndOnDragOver}
            onDrop={dndDropOnOptions}
          >
            {normalizedOptions.map((option) => {
              const isUsed = generalDragAnswer.includes(option.id);

              return (
                <button
                  key={option.id}
                  type="button"
                  className={`decision-dnd-option-bc ${isUsed ? 'used' : ''}`}
                  draggable={!isUsed}
                  onDragStart={(event) => !isUsed && dndDragStartOption(event, option.id)}
                  onClick={() => !isUsed && dndOptionClick(option.id)}
                  disabled={isUsed}
                >
                  {!isUsed && option.label}
                </button>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}

case 'decisionFlowApplication': {
  const step = currentQuestion.steps[decisionStepIndex];

  /* =========================
     ECRAN 1 – CONTEXT (doar afișare)
     ========================= */
  if (decisionPhase === 'intro') {
    return (
      <div className="simple-application-container-bc">
        <div className="simple-application-instruction-bc">
          <div className="simple-application-content-bc">






       

          <div className="simple-application-context-bc">
            <div
              dangerouslySetInnerHTML={{
                __html: currentQuestion.context || ''
              }}
            />
          </div>









 </div>
        </div>
      </div>
    );
  }

  /* =========================
     ECRAN FINAL – CONCLUZIE (doar afișare)
     ========================= */
  if (decisionPhase === 'final') {
    return (
      <div className="simple-application-container-bc">
        <div className="simple-application-instruction-bc">
          <div className="simple-application-content-bc">

          <h2 className="motivational-title">
            Aplicatie finalizata
          </h2>

         <div
  dangerouslySetInnerHTML={{
    __html: currentQuestion.finalMessage ||
      '<p>Aplicatie finalizata cu succes.</p>'
  }}
/>


          <p>
            <b>
              Scor: {currentQuestion.steps.length} / {currentQuestion.steps.length}
            </b> ⭐⭐⭐
          </p>

         </div>
         </div>
      </div>
    );
  }

  /* =========================
     PAȘII (quiz normal, fără butoane)
     ========================= */
  const optionType =
    step.optionType ||
    step.stepType ||
    (typeof step.type === 'string' && step.type.startsWith('option') ? step.type : 'simpleOption'); // Accepta si step.type
  const isFormulaLayout =
    optionType === 'optionDragAndDropFormula' ||
    optionType === 'optionDragAndDropFormulaLeft' ||
    optionType === 'optionDragAndDropFormulaRight';
  const isFormulaLeftLayout = optionType === 'optionDragAndDropFormulaLeft';
  const isFormulaRightLayout = optionType === 'optionDragAndDropFormulaRight';
  const isTaccountLayout = optionType === 'optionDragTaccount';
  const isDragAndDrop = optionType === 'optionDragAndDrop' || isFormulaLayout || isTaccountLayout;

  // Para drag and drop
  if (isDragAndDrop) {
    const normalizedOptions = shuffledDecisionDragOptions.length
      ? shuffledDecisionDragOptions
      : (Array.isArray(step.options) ? step.options : []).map((value, idx) => ({
          id: buildDecisionOptionId(idx),
          value,
          label: String(value),
        }));

    const slotsCount = getDecisionDragSlotsCount(step);
    const expectedAnswers = Array.isArray(step.correctAnswer) ? step.correctAnswer : [];
    const rows = Array.isArray(step.rows) && step.rows.length > 0
      ? step.rows
      : [{ label: '', slots: slotsCount }];

    const prefilledSlots = Array.isArray(step.prefilledSlots) ? step.prefilledSlots : [];
    const prefilledSlotIndexes = new Set(
      prefilledSlots
        .map((value, index) => (value !== null && value !== undefined && value !== '' ? index : -1))
        .filter((index) => index >= 0 && index < slotsCount)
    );

    const taccountSideLabels = Array.isArray(step.taccountSideLabels) && step.taccountSideLabels.length === 2
      ? step.taccountSideLabels
      : ['D', 'C'];

    const taccountLabel = typeof step.taccountLabel === 'string' && step.taccountLabel.trim() !== ''
      ? step.taccountLabel.trim()
      : Array.isArray(step.taccountLabels) && step.taccountLabels.length > 0
      ? String(step.taccountLabels[0]).trim()
      : '';

    const taccountInitialLabel = typeof step.taccountInitialLabel === 'string' && step.taccountInitialLabel.trim() !== ''
      ? step.taccountInitialLabel.trim()
      : 'Sold inițial';
    const taccountRulajLabel = typeof step.taccountRulajLabel === 'string' && step.taccountRulajLabel.trim() !== ''
      ? step.taccountRulajLabel.trim()
      : 'Rulaj';
    const taccountFinalLabel = typeof step.taccountFinalLabel === 'string' && step.taccountFinalLabel.trim() !== ''
      ? step.taccountFinalLabel.trim()
      : 'Sold final';

    const taccountInitialRows = Number(step.taccountInitialRows) || 2;
    const taccountFinalRows = Number(step.taccountFinalRows) || 1;

    const tAccountLeftSlots = isTaccountLayout ? Math.ceil(slotsCount / 2) : 0;
    const tAccountRightSlots = isTaccountLayout ? slotsCount - tAccountLeftSlots : 0;
    const tAccountLeftIndexes = isTaccountLayout
      ? Array.from({ length: tAccountLeftSlots }, (_, idx) => idx)
      : [];
    const tAccountRightIndexes = isTaccountLayout
      ? Array.from({ length: tAccountRightSlots }, (_, idx) => tAccountLeftSlots + idx)
      : [];

    const tAccountLeftInitialCount = Math.max(0, Math.min(tAccountLeftSlots - taccountFinalRows, taccountInitialRows));
    const tAccountRightInitialCount = Math.max(0, Math.min(tAccountRightSlots - taccountFinalRows, taccountInitialRows));
    const tAccountLeftFinalCount = Math.max(0, Math.min(taccountFinalRows, tAccountLeftSlots));
    const tAccountRightFinalCount = Math.max(0, Math.min(taccountFinalRows, tAccountRightSlots));

    const tAccountLeftInitialIndexes = tAccountLeftIndexes.slice(0, tAccountLeftInitialCount);
    const tAccountLeftFinalIndexes = tAccountLeftFinalCount > 0
      ? tAccountLeftIndexes.slice(-tAccountLeftFinalCount)
      : [];
    const tAccountLeftRulajIndexes = tAccountLeftIndexes.slice(tAccountLeftInitialCount, tAccountLeftIndexes.length - tAccountLeftFinalCount);

    const tAccountRightInitialIndexes = tAccountRightIndexes.slice(0, tAccountRightInitialCount);
    const tAccountRightFinalIndexes = tAccountRightFinalCount > 0
      ? tAccountRightIndexes.slice(-tAccountRightFinalCount)
      : [];
    const tAccountRightRulajIndexes = tAccountRightIndexes.slice(tAccountRightInitialCount, tAccountRightIndexes.length - tAccountRightFinalCount);

    const dndOnDragOver = (event) => {
      event.preventDefault();
    };

    const dndReadDraggedValue = (event) => {
      try {
        const payload = event.dataTransfer.getData('application/json');
        if (payload) {
          const parsed = JSON.parse(payload);
          if (parsed && parsed.id) return parsed.id;
        }
      } catch (err) {
        // fallback
      }

      const textValue = event.dataTransfer.getData('text/plain');
      if (!textValue) return textValue;

      try {
        const parsed = JSON.parse(textValue);
        if (parsed && parsed.id) return parsed.id;
      } catch (err) {
        // not JSON, return plain text
      }

      return textValue;
    };

    const updateDragState = (next) => {
      setDecisionDragAnswer(next);
      const hasSelection = next.some(
        (item) => item !== null && item !== undefined && item !== ''
      );
      setDesableButton(!hasSelection);
      if (hasSelection) {
        setTextButton('Verifica');
        setChangeColorButton(true);
      }
    };

    const dndPlaceInSlot = (slotIndex, optionId) => {
      if (isAnswerChecked || prefilledSlotIndexes.has(slotIndex)) return;

      const next = Array.isArray(decisionDragAnswer) && decisionDragAnswer.length === slotsCount
        ? [...decisionDragAnswer]
        : Array(slotsCount).fill(null);

      const existingIndex = next.indexOf(optionId);
      if (existingIndex !== -1) {
        next[existingIndex] = null;
      }

      next[slotIndex] = optionId;
      updateDragState(next);
    };

    const dndDropOnSlot = (event, slotIndex) => {
      event.preventDefault();
      event.stopPropagation();
      const optionId = dndReadDraggedValue(event);
      if (!optionId) return;
      dndPlaceInSlot(slotIndex, optionId);
    };

    const dndDropOnOptions = (event) => {
      event.preventDefault();
      if (isAnswerChecked) return;

      const optionId = dndReadDraggedValue(event);
      if (!optionId) return;

      const next = (Array.isArray(decisionDragAnswer) ? decisionDragAnswer : Array(slotsCount).fill(null))
        .map((item) => (item === optionId ? null : item));
      updateDragState(next);
    };

    const dndDropOnColumn = (event, columnSlotIndexes) => {
      event.preventDefault();
      event.stopPropagation();
      if (isAnswerChecked) return;

      const optionId = dndReadDraggedValue(event);
      if (!optionId) return;

      const next = Array.isArray(decisionDragAnswer) ? [...decisionDragAnswer] : Array(slotsCount).fill(null);
      const firstEmptyIndex = columnSlotIndexes.find((slotIndex) => {
        const item = next[slotIndex];
        return item === null || item === undefined || item === '';
      });

      if (firstEmptyIndex !== undefined) {
        dndPlaceInSlot(firstEmptyIndex, optionId);
      }
    };

    const dndSlotClick = (slotIndex) => {
      if (isAnswerChecked || prefilledSlotIndexes.has(slotIndex)) return;

      if (selectedDecisionDragOptionId) {
        dndPlaceInSlot(slotIndex, selectedDecisionDragOptionId);
        setSelectedDecisionDragOptionId(null);
        return;
      }

      const next = Array.isArray(decisionDragAnswer) ? [...decisionDragAnswer] : Array(slotsCount).fill(null);
      next[slotIndex] = null;
      updateDragState(next);
    };

    const dndOptionClick = (optionId) => {
      if (isAnswerChecked) return;

      // Găsim primul slot gol (neprefilled) și plasăm direct opțiunea acolo
      const current = Array.isArray(decisionDragAnswer) && decisionDragAnswer.length === slotsCount
        ? [...decisionDragAnswer]
        : Array(slotsCount).fill(null);

      const firstEmptySlot = Array.from({ length: slotsCount }, (_, i) => i)
        .find(i => !prefilledSlotIndexes.has(i) && (current[i] === null || current[i] === undefined || current[i] === ''));

      if (firstEmptySlot !== undefined) {
        dndPlaceInSlot(firstEmptySlot, optionId);
        setSelectedDecisionDragOptionId(null);
      } else {
        // Dacă nu există slot gol, doar selectăm/deselectăm
        if (selectedDecisionDragOptionId === optionId) {
          setSelectedDecisionDragOptionId(null);
        } else {
          setSelectedDecisionDragOptionId(optionId);
        }
      }
    };

    const dndDragStartOption = (event, optionId) => {
      event.dataTransfer.effectAllowed = 'move';
      event.dataTransfer.dropEffect = 'move';
      event.dataTransfer.setData('application/json', JSON.stringify({ id: optionId }));
      event.dataTransfer.setData('text/plain', String(optionId));
    };

    const clearTouchHoveredSlot = () => {
      if (touchDecisionHoveredSlotRef.current) {
        touchDecisionHoveredSlotRef.current.classList.remove('touch-target');
        touchDecisionHoveredSlotRef.current = null;
      }
    };

    const updateTouchHoveredSlot = (clientX, clientY) => {
      const target = document.elementFromPoint(clientX, clientY);
      const slotElement = target ? target.closest('[data-decision-slot-index]') : null;

      if (slotElement === touchDecisionHoveredSlotRef.current) {
        return;
      }

      clearTouchHoveredSlot();

      if (slotElement) {
        slotElement.classList.add('touch-target');
        touchDecisionHoveredSlotRef.current = slotElement;
      }
    };

    const updateTouchDragPreviewPosition = (clientX, clientY) => {
      const previewElement = touchDecisionPreviewRef.current;
      if (!previewElement) return;

      previewElement.style.left = `${clientX}px`;
      previewElement.style.top = `${clientY}px`;
    };

    const clearTouchDragPreview = () => {
      if (touchDecisionSourceRef.current) {
        touchDecisionSourceRef.current.classList.remove('touch-drag-source');
        touchDecisionSourceRef.current = null;
      }

      if (touchDecisionPreviewRef.current) {
        touchDecisionPreviewRef.current.remove();
        touchDecisionPreviewRef.current = null;
      }
    };

    const dndTouchStartOption = (event, optionId, optionLabel) => {
      if (isAnswerChecked) return;
      const touch = event.touches && event.touches[0];
      if (!touch) return;

      clearTouchHoveredSlot();
      clearTouchDragPreview();

      if (event.currentTarget) {
        event.currentTarget.classList.add('touch-drag-source');
        touchDecisionSourceRef.current = event.currentTarget;
      }

      const previewElement = document.createElement('div');
      previewElement.className = 'touch-drag-preview-bc';
      previewElement.textContent = String(optionLabel ?? '');
      document.body.appendChild(previewElement);
      touchDecisionPreviewRef.current = previewElement;
      updateTouchDragPreviewPosition(touch.clientX, touch.clientY);

      touchDecisionOptionIdRef.current = optionId;
      touchDecisionStartRef.current = { x: touch.clientX, y: touch.clientY };
      touchDecisionMovedRef.current = false;
    };

    const dndTouchMoveOption = (event) => {
      if (!touchDecisionOptionIdRef.current) return;
      const touch = event.touches && event.touches[0];
      if (!touch) return;

      updateTouchDragPreviewPosition(touch.clientX, touch.clientY);

      const deltaX = Math.abs(touch.clientX - touchDecisionStartRef.current.x);
      const deltaY = Math.abs(touch.clientY - touchDecisionStartRef.current.y);
      const hasMoved = deltaX > 8 || deltaY > 8;

      if (hasMoved) {
        touchDecisionMovedRef.current = true;
        updateTouchHoveredSlot(touch.clientX, touch.clientY);
        // Opreste scroll-ul paginii cat timp utilizatorul gliseaza o optiune
        event.preventDefault();
      }
    };

    const dndTouchCancelOption = () => {
      touchDecisionOptionIdRef.current = null;
      touchDecisionMovedRef.current = false;
      clearTouchHoveredSlot();
      clearTouchDragPreview();
    };

    const dndTouchEndOption = (event) => {
      const optionId = touchDecisionOptionIdRef.current;
      const hasMoved = touchDecisionMovedRef.current;

      touchDecisionOptionIdRef.current = null;
      touchDecisionMovedRef.current = false;
      clearTouchHoveredSlot();
      clearTouchDragPreview();

      if (!optionId || !hasMoved) return;

      event.preventDefault();
      const touch = event.changedTouches && event.changedTouches[0];
      if (!touch) return;

      const dropElement = document.elementFromPoint(touch.clientX, touch.clientY);
      if (!dropElement) return;

      const slotElement = dropElement.closest('[data-decision-slot-index]');
      if (slotElement) {
        const slotIndex = Number(slotElement.getAttribute('data-decision-slot-index'));
        if (Number.isInteger(slotIndex)) {
          dndPlaceInSlot(slotIndex, optionId);
          setSelectedDecisionDragOptionId(null);
        }
        return;
      }

      const optionsArea = dropElement.closest('[data-decision-options-area="true"]');
      if (optionsArea) {
        const next = (Array.isArray(decisionDragAnswer) ? decisionDragAnswer : Array(slotsCount).fill(null))
          .map((item) => (item === optionId ? null : item));
        updateDragState(next);
        setSelectedDecisionDragOptionId(null);
      }
    };

    const renderDecisionSlot = (slotIndex, sectionLabel) => {
      const optionId = (Array.isArray(decisionDragAnswer) && decisionDragAnswer[slotIndex] !== undefined) ? decisionDragAnswer[slotIndex] : null;
      const value = getDecisionOptionValueById(step, optionId) || '';
      const expectedValue = expectedAnswers[slotIndex] ?? '';
      const isCorrectSlot = isAnswerChecked && value && value === expectedValue;
      const isWrongSlot = isAnswerChecked && value && value !== expectedValue;

      const isSlotPrefilled = prefilledSlotIndexes.has(slotIndex);

      return (
        <button
          key={`decision-dnd-slot-${slotIndex}`}
          type="button"
          data-decision-slot-index={slotIndex}
          className={`decision-dnd-slot-bc ${value ? 'filled' : ''} ${isSlotPrefilled ? 'prefilled' : ''} ${isCorrectSlot ? 'correct' : ''} ${isWrongSlot ? 'incorrect' : ''}`}
          onDragOver={dndOnDragOver}
          onDrop={(event) => dndDropOnSlot(event, slotIndex)}
          onClick={() => dndSlotClick(slotIndex)}
          draggable={!isAnswerChecked && Boolean(optionId) && !isSlotPrefilled}
          onDragStart={(event) => !isSlotPrefilled && optionId && dndDragStartOption(event, optionId)}
          disabled={isAnswerChecked || isSlotPrefilled}
        >
          {!value && !isSlotPrefilled && (
            <span className="decision-dnd-slot-placeholder-bc">{sectionLabel}</span>
          )}
          {value && <span className='decision-dnd-slot-bc-filled-style'>{value}</span>}
        </button>
      );
    };

    const renderTaccountSection = (indexes, label) => {
      if (indexes.length === 0) return null;
      return (
        <div className="decision-taccount-section-bc">
          {indexes.map((slotIndex) => renderDecisionSlot(slotIndex, label))}
        </div>
      );
    };

    let currentSlotIndex = 0;

    return (
      <div className="simple-application-container-bc">
        <div className="simple-application-instruction-bc">
          <div className="simple-application-content-bc">

         

            <div className="simple-application-question-bc">
              <p>{step.question}</p>
            </div>

            <div className={`decision-dnd-container-bc${isFormulaLayout ? ' formula' : ''}${isFormulaLeftLayout ? ' formula-left' : ''}${isFormulaRightLayout ? ' formula-right' : ''}${isTaccountLayout ? ' taccount' : ''}`}>
              {isTaccountLayout ? (
                <div className="decision-taccount-shell-bc">
                  <div className="decision-taccount-header-bc">
                    <div className="decision-taccount-column-title-bc">
                      <span className="decision-taccount-side-label-bc">{taccountSideLabels[0]}</span>
                    </div>
                    <div className="decision-taccount-column-title-bc decision-taccount-center-title-bc">
                      <span className="decision-taccount-account-name-bc">{taccountLabel}</span>
                       
                    </div>
                    
                    <div className="decision-taccount-column-title-bc">

                     
                      <span className="decision-taccount-side-label-bc">{taccountSideLabels[1]}</span>
                    </div>
                  </div>

                  <div className='line-t-grad-and-drop-account'></div>

                  <div className="decision-taccount-grid-bc">
                    <div
                      className="decision-taccount-column-bc"
                      onDragOver={dndOnDragOver}
                      onDrop={(event) => dndDropOnColumn(event, tAccountLeftIndexes)}
                    >
                      {renderTaccountSection(tAccountLeftInitialIndexes, taccountInitialLabel)}
                      {renderTaccountSection(tAccountLeftRulajIndexes, taccountRulajLabel)}
                      {renderTaccountSection(tAccountLeftFinalIndexes, taccountFinalLabel)}
                    </div>
                    <div className="decision-taccount-divider-bc" />
                    <div
                      className="decision-taccount-column-bc"
                      onDragOver={dndOnDragOver}
                      onDrop={(event) => dndDropOnColumn(event, tAccountRightIndexes)}
                    >
                      {renderTaccountSection(tAccountRightInitialIndexes, taccountInitialLabel)}
                      {renderTaccountSection(tAccountRightRulajIndexes, taccountRulajLabel)}
                      {renderTaccountSection(tAccountRightFinalIndexes, taccountFinalLabel)}
                    </div>
                  </div>
                </div>
              ) : isFormulaLeftLayout ? (
                (() => {
                  const formulaTopCount = Math.max(0, Number(step.topRowCount) || 4);
                  const remainingSlots = Math.max(0, slotsCount - formulaTopCount);
                  const formulaLeftCount = Math.max(0, Number(step.leftColCount) || Math.floor(remainingSlots / 2));
                  const formulaRightCount = Math.max(0, remainingSlots - formulaLeftCount);
                  const formulaLeftLayoutStyle = {
                    '--formula-left-top-count': formulaTopCount,
                  };

                  return (
                    <>
                      <div className="decision-dnd-formula-left-top-bc" style={formulaLeftLayoutStyle}>
                        {Array.from({ length: formulaTopCount }, (_, idx) => renderDecisionSlot(idx))}
                      </div>

                      <div className="decision-dnd-formula-left-middle-bc" style={formulaLeftLayoutStyle}>
                        <div className="decision-dnd-formula-left-col-bc">
                          {Array.from({ length: formulaLeftCount }, (_, idx) => renderDecisionSlot(formulaTopCount + idx))}
                        </div>
                        <div className="decision-dnd-formula-left-spacer-bc" />
                        <div className="decision-dnd-formula-left-col-bc">
                          {Array.from({ length: formulaRightCount }, (_, idx) => renderDecisionSlot(formulaTopCount + formulaLeftCount + idx))}
                        </div>
                      </div>
                    </>
                  );
                })()
              ) : isFormulaRightLayout ? (
                (() => {
                  const formulaTopCount = Math.max(0, Number(step.topRowCount) || 4);
                  const remainingSlots = Math.max(0, slotsCount - formulaTopCount);
                  const formulaMidLeftCount = Math.max(0, Number(step.rightInnerColCount) || Math.floor(remainingSlots / 2));
                  const formulaMidRightCount = Math.max(0, remainingSlots - formulaMidLeftCount);
                  const formulaRightLayoutStyle = {
                    '--formula-right-top-count': formulaTopCount,
                  };

                  return (
                    <>
                      <div className="decision-dnd-formula-right-top-bc" style={formulaRightLayoutStyle}>
                        {Array.from({ length: formulaTopCount }, (_, idx) => renderDecisionSlot(idx))}
                      </div>

                      <div className="decision-dnd-formula-right-middle-bc" style={formulaRightLayoutStyle}>
                        <div className="decision-dnd-formula-right-col-bc">
                          {Array.from({ length: formulaMidLeftCount }, (_, idx) => renderDecisionSlot(formulaTopCount + idx))}
                        </div>
                        <div className="decision-dnd-formula-right-col-bc">
                          {Array.from({ length: formulaMidRightCount }, (_, idx) => renderDecisionSlot(formulaTopCount + formulaMidLeftCount + idx))}
                        </div>
                      </div>
                    </>
                  );
                })()
              ) : (
                rows.map((row, rowIndex) => {
                  const rowSlots = Math.max(0, Number(row?.slots) || 0);
                  const rowLabel = isFormulaLayout ? '' : row?.label ?? '';
                  const startIndex = currentSlotIndex;
                  currentSlotIndex += rowSlots;

                  return (
                    <div key={`decision-dnd-row-${rowIndex}`} className={`decision-dnd-row-bc${isFormulaLayout ? ' formula' : ''}`}>
                      {rowLabel && <p className="decision-dnd-row-label-bc">{rowLabel}</p>}
                      <div className="decision-dnd-row-slots-bc">
                        {Array.from({ length: rowSlots }, (_, idx) => renderDecisionSlot(startIndex + idx))}
                      </div>
                    </div>
                  );
                })
              )}
            </div>

            {!isAnswerChecked && (
              <div
                className="decision-dnd-options-bc"
                data-decision-options-area="true"
                onDragOver={dndOnDragOver}
                onDrop={dndDropOnOptions}
              >
                {normalizedOptions.map((option) => {
                  const isUsed = decisionDragAnswer.includes(option.id);

                  return (
                    <button
                      key={option.id}
                      type="button"
                      className={`decision-dnd-option-bc ${isUsed ? 'used' : ''} ${selectedDecisionDragOptionId === option.id ? 'selected' : ''}`}
                      draggable={!isUsed}
                      onDragStart={(event) => {
                        if (!isUsed) dndDragStartOption(event, option.id);
                      }}
                      onClick={() => {
                        if (!isUsed) dndOptionClick(option.id);
                      }}
                      onTouchStart={(event) => {
                        if (!isUsed) dndTouchStartOption(event, option.id, option.label);
                      }}
                      onTouchMove={(event) => {
                        if (!isUsed) dndTouchMoveOption(event);
                      }}
                      onTouchEnd={(event) => {
                        if (!isUsed) dndTouchEndOption(event);
                      }}
                      onTouchCancel={() => {
                        if (!isUsed) dndTouchCancelOption();
                      }}
                    >
                      {!isUsed && option.label}
                    </button>
                  );
                })}
              </div>
            )}

          </div>
        </div>
      </div>
    );
  }

  // Pentru simpleOption și multipleOption
  const isMultiple = optionType === 'multipleOption';

  return (
    <div className="simple-application-container-bc">
        <div className="simple-application-instruction-bc">
          <div className="simple-application-content-bc">

    

        <div className="simple-application-question-bc">
          <p>{step.question}</p>
        </div>

      



          <div className={isMultiple ? 'multiple-answer-lessons-bc' : 'simple-application-buttons-bc'}>
            {shuffledDecisionOptions.map(option => {
              if (isMultiple) {
                const isSelected = decisionSelectedAnswers.includes(option);
                const isCorrect = Array.isArray(step.correctAnswer) && step.correctAnswer.includes(option);

                const borderClass = isAnswerChecked
                  ? isCorrect
                    ? 'border-correct'
                    : isSelected
                    ? 'border-incorrect'
                    : ''
                  : isSelected
                  ? 'border-selected'
                  : '';

                return (
                  <div
                    key={option}
                    className={`align-multiple-items-bc ${borderClass}`}
                    onClick={() => {
                      if (isAnswerChecked) return;

                      setDecisionSelectedAnswers(prev => {
                        const updated = prev.includes(option)
                          ? prev.filter(ans => ans !== option)
                          : [...prev, option];

                        setDesableButton(updated.length === 0);
                        if (updated.length > 0) {
                          setTextButton('Verifica');
                          setChangeColorButton(true);
                        }
                        return updated;
                      });
                    }}
                  >
                    <input
                      type="checkbox"
                      checked={isSelected}
                      readOnly
                      className="check-box-multiple-answer-bc"
                    />
                    <span>{option}</span>
                  </div>
                );
              }

              const className = isAnswerChecked
                ? option === step.correctAnswer
                  ? 'simple-application-correct-bc'
                  : option === decisionAnswer
                  ? 'simple-application-incorrect-bc'
                  : 'simple-application-default-bc'
                : decisionAnswer === option
                ? 'simple-application-selected-bc'
                : 'simple-application-default-bc';

              return (
                <div
                  key={option}
                  className={className}
                  onClick={() => {
                    if (isAnswerChecked) return;
                    setDecisionAnswer(option);
                    setDesableButton(false);
                    setTextButton('Verifica');
                    setChangeColorButton(true);
                  }}
                >
                  <b>{option}</b>
                </div>
              );
            })}
          </div>

        </div>
      </div>
    </div>
  );
}



        case 'manualInput':
          return (
            <div className="quiz-content-scroll-bc">
            <div className='explanation-lesoon-container-bc'>
              <h4 className='tittle-sescrition-lesson'><strong>{currentQuestion.question}</strong></h4>
        
              <div className='align-input-items'>
                {currentQuestion.correctAnswer.map((answer, index) => {
                  const isCorrect = Number(userInput[index]) === answer.code; // Verifică dacă răspunsul este corect
                  const inputClass = isAnswerChecked
                    ? isCorrect
                      ? 'answer-input-correct'
                      : 'answer-input-incorrect'
                    : 'answer-input-item-complete';
        
                  return (
                    <div className='' key={index}>
                      <div className='input-item-answer-type'>
                        <input
                          className={inputClass}
                          type="number"
                          maxLength='4'
                          value={userInput[index] || ''}
                          onChange={(e) => { 
                            handleInputChange(index, e.target.value); 
                            setDesableButton(false);
                          }}
                          disabled={isAnswerChecked}
                        />
                        <p className='input-title-element-answer'>{answer.label}</p>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
            </div>
          );


          

case 'dragAndDropHorizontal': {
  const normalizedOptions = shuffledDragHorizontalOptions.length
    ? shuffledDragHorizontalOptions
    : normalizeHorizontalDragOptions(currentQuestion);

  const slotsCount = getHorizontalDragSlotsCount(currentQuestion);
  const expectedAnswers = getHorizontalDragExpectedAnswers(currentQuestion).map((item) => String(item));
  const rows = getHorizontalDragRows(currentQuestion);
  const sentenceSegments = getHorizontalSentenceSegments(currentQuestion);
  const hasInlineSentence = sentenceSegments.length > 0;

  const dndOnDragOver = (event) => {
    event.preventDefault();
  };

  const dndReadDraggedValue = (event) => {
    try {
      const payload = event.dataTransfer.getData('application/json');
      if (payload) {
        const parsed = JSON.parse(payload);
        if (parsed && parsed.id) return parsed.id;
      }
    } catch (err) {
      // fallback
    }

    return event.dataTransfer.getData('text/plain');
  };

  const updateHorizontalDragState = (next) => {
    setDataReceived(next);
    const hasSelection = next.some(
      (item) => item !== null && item !== undefined && item !== ''
    );
    setDesableButton(!hasSelection);
    if (hasSelection) {
      setTextButton('Verifica');
      setChangeColorButton(true);
    }
  };

  const dndPlaceInSlot = (slotIndex, optionId) => {
    if (isAnswerChecked) return;

    const next = Array.isArray(dataReceived) && dataReceived.length === slotsCount
      ? [...dataReceived]
      : Array(slotsCount).fill(null);

    const existingIndex = next.indexOf(optionId);
    if (existingIndex !== -1) {
      next[existingIndex] = null;
    }

    next[slotIndex] = optionId;
    updateHorizontalDragState(next);
  };

  const dndDropOnSlot = (event, slotIndex) => {
    event.preventDefault();
    const optionId = dndReadDraggedValue(event);
    if (!optionId) return;
    dndPlaceInSlot(slotIndex, optionId);
  };

  const dndDropOnOptions = (event) => {
    event.preventDefault();
    if (isAnswerChecked) return;

    const optionId = dndReadDraggedValue(event);
    if (!optionId) return;

    const next = (Array.isArray(dataReceived) ? dataReceived : Array(slotsCount).fill(null))
      .map((item) => (item === optionId ? null : item));
    updateHorizontalDragState(next);
  };

  const dndSlotClick = (slotIndex) => {
    if (isAnswerChecked) return;

    const next = Array.isArray(dataReceived) ? [...dataReceived] : Array(slotsCount).fill(null);
    next[slotIndex] = null;
    updateHorizontalDragState(next);
  };

  const dndOptionClick = (optionId) => {
    if (isAnswerChecked) return;

    const firstEmpty = (Array.isArray(dataReceived) ? dataReceived : Array(slotsCount).fill(null)).findIndex(
      (item) => item === null || item === undefined || item === ''
    );
    if (firstEmpty !== -1) {
      dndPlaceInSlot(firstEmpty, optionId);
    }
  };

  const dndDragStartOption = (event, optionId) => {
    event.dataTransfer.setData('application/json', JSON.stringify({ id: optionId }));
    event.dataTransfer.setData('text/plain', String(optionId));
  };

  let currentSlotIndex = 0;

  return (
    <div className="quiz-content-scroll-bc">
      <div className="explanation-lesoon-container-bc">
        <div className="title-simple-select-align">
          <p className="centred-simple-element">
            {currentQuestion.question}
          </p>
        </div>

        {hasInlineSentence ? (
          <div className="horizontal-equation-layout-bc">
            {sentenceSegments.map((segment, index) => {
              const isSlotSegment =
                segment === '__SLOT__' ||
                segment === '{{slot}}' ||
                (typeof segment === 'string' && /^_{3,}$/.test(segment));

              if (!isSlotSegment) {
                return (
                  <span key={`horizontal-inline-text-${index}`} className="equation-static-chunk">
                    {segment}{' '}
                  </span>
                );
              }

              const slotIndex = currentSlotIndex;
              currentSlotIndex += 1;

              const optionId = dataReceived[slotIndex] ?? null;
              const value = getHorizontalOptionValueById(currentQuestion, optionId) || '';
              const expectedValue = expectedAnswers[slotIndex] ?? '';
              const isCorrectSlot = isAnswerChecked && value && value === expectedValue;
              const isWrongSlot = isAnswerChecked && value && value !== expectedValue;

              return (
                <button
                  key={`horizontal-inline-slot-${slotIndex}`}
                  type="button"
                  className={`decision-dnd-slot-bc ${value ? 'filled' : ''} ${isCorrectSlot ? 'correct' : ''} ${isWrongSlot ? 'incorrect' : ''}`}
                  onDragOver={dndOnDragOver}
                  onDrop={(event) => dndDropOnSlot(event, slotIndex)}
                  onClick={() => dndSlotClick(slotIndex)}
                  draggable={!isAnswerChecked && Boolean(optionId)}
                  onDragStart={(event) => optionId && dndDragStartOption(event, optionId)}
                  disabled={isAnswerChecked}
                >
                  {value && <span className='decision-dnd-slot-bc-filled-style'>{value}</span>}
                </button>
              );
            })}
          </div>
        ) : (
          <div className="decision-dnd-container-bc">
            {rows.map((row, rowIndex) => {
              const rowSlots = Math.max(0, Number(row?.slots) || 0);
              const rowLabel = currentQuestion.type === 'orderSelectionDrag' ? '' : (row?.label ?? '');
              const startIndex = currentSlotIndex;
              currentSlotIndex += rowSlots;

              return (
                <div key={`horizontal-dnd-row-${rowIndex}`} className="decision-dnd-row-bc">
                  {rowLabel && <p className="decision-dnd-row-label-bc">{rowLabel}</p>}
                  <div className="decision-dnd-row-slots-bc">
                    {Array.from({ length: rowSlots }, (_, idx) => {
                      const slotIndex = startIndex + idx;
                      const optionId = dataReceived[slotIndex] ?? null;
                      const value = getHorizontalOptionValueById(currentQuestion, optionId) || '';
                      const expectedValue = expectedAnswers[slotIndex] ?? '';
                      const isCorrectSlot = isAnswerChecked && value && value === expectedValue;
                      const isWrongSlot = isAnswerChecked && value && value !== expectedValue;

                      return (
                        <button
                          key={`horizontal-dnd-slot-${slotIndex}`}
                          type="button"
                          className={`decision-dnd-slot-bc ${value ? 'filled' : ''} ${isCorrectSlot ? 'correct' : ''} ${isWrongSlot ? 'incorrect' : ''}`}
                          onDragOver={dndOnDragOver}
                          onDrop={(event) => dndDropOnSlot(event, slotIndex)}
                          onClick={() => dndSlotClick(slotIndex)}
                          draggable={!isAnswerChecked && Boolean(optionId)}
                          onDragStart={(event) => optionId && dndDragStartOption(event, optionId)}
                          disabled={isAnswerChecked}
                        >
                          {value && <span className='decision-dnd-slot-bc-filled-style'>{value}</span>}
                        </button>
                      );
                    })}
                  </div>
                </div>
              );
            })}
          </div>
        )}

        {!isAnswerChecked && (
          <div
            className="decision-dnd-options-bc"
            onDragOver={dndOnDragOver}
            onDrop={dndDropOnOptions}
          >
            {normalizedOptions.map((option) => {
              const isUsed = dataReceived.includes(option.id);

              return (
                <button
                  key={option.id}
                  type="button"
                  className={`decision-dnd-option-bc ${isUsed ? 'used' : ''}`}
                  draggable={!isUsed}
                  onDragStart={(event) => !isUsed && dndDragStartOption(event, option.id)}
                  onClick={() => !isUsed && dndOptionClick(option.id)}
                  disabled={isUsed}
                >
                  {!isUsed && option.label}
                </button>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}



         case 'dragAndDropOneAnswer': {
  const handleDragItemClick = (code) => {
    if (isAnswerChecked) return;
    if (dataReceived.includes(code)) return;

    setDataReceived([code]);
    setTextButton('Verifica');
  };

  const handleBoxClick = () => {
    if (isAnswerChecked) return;

    setDataReceived([]);
    setTextButton('Verifica');
  };

  return (
    <div className="quiz-content-scroll-bc">
      <div className="explanation-lesoon-container-bc">

        {/* Propoziția completabilă */}
        <div className="horizontal-equation-layout-bc">
          <p className="equation-box-static-bc">
            <span>{currentQuestion.correctAnswer[0]} </span>

            <span
              className={`equation-box-bc ${
                isAnswerChecked ? '' : 'cursor-pointer'
              }`}
              onClick={handleBoxClick}
            >
              {dataReceived[0] || ''}
            </span>

            <span> {currentQuestion.correctAnswer[2]}</span>
          </p>
        </div>

        {/* Opțiuni */}
        {!isAnswerChecked && (
          <div className="horizontal-options-bc">
          {shuffledDragOneOptions.map(option => {

  const isUsed = dataReceived.includes(option.code);

  return (
    <button
      key={option.code}   // ✅ CHEIE STABILĂ → RANDOM FUNCȚIONEAZĂ
      className={`equation-option-btn-bc ${
        isUsed ? 'placeholder-btn' : ''
      }`}
      onClick={() => handleDragItemClick(option.code)}
    >
      {option.code}
    </button>
  );
})}

          </div>
        )}

      </div>
    </div>
  );
}

   

          
          
          
          

        case 'multipleSelect':



          return (
            <div className="quiz-content-scroll-bc">
            <div className='explanation-lesoon-container-bc'>
              <div className='title-simple-select-align'>
                
              <div className="centred-simple-element">
               <span className="question-text-bc">{currentQuestion.question}</span>
              
              </div>  

                  </div>



               




              <div className='multiple-answer-lessons-bc'>
     {shuffledMultipleOptions.map(option => {

  const isSelected = selectedAnswers.includes(option);
  const isCorrect = currentQuestion.correctAnswer.includes(option);

  let checkboxClass = 'check-box-multiple-answer-bc';

  if (isAnswerChecked) {
    if (isCorrect) {
      checkboxClass = 'checkbox-correct';
    } else if (isSelected && !isCorrect) {
      checkboxClass = 'checkbox-incorrect';
    }
  }

  return (
    <div
      key={option}
      className={`align-multiple-items-bc ${
        isAnswerChecked
          ? isCorrect
            ? 'border-correct'
            : isSelected
            ? 'border-incorrect'
            : ''
          : isSelected
          ? 'border-selected'
          : ''
      }`}
      onClick={() => {
        if (isAnswerChecked) return;
        handleCheckboxChange(option);
      }}
    >
      <input
        className={checkboxClass}
        type="checkbox"
        checked={isSelected}
        readOnly
      />

      <span className="cursor-pointer">
        {option}
      </span>
    </div>
  );
})}


              </div>
            </div>
            </div>
          );

        case 'optionDragAndDropFormulaLeft': {
          const odflNormalizedOptions = (shuffledOptionDragAndDropFormulaLeftOptions.length
            ? shuffledOptionDragAndDropFormulaLeftOptions
            : (currentQuestion.options || [])
          ).map((option, index) => {
            if (option && typeof option === 'object') {
              const value = option.code ?? option.value ?? option.label ?? '';
              const label = option.label ?? option.code ?? option.value ?? '';
              return { id: option.id ?? `${String(value)}-${index}`, value: String(value), label: String(label) };
            }
            return { id: `${String(option)}-${index}`, value: String(option), label: String(option) };
          });

          const odflSlotsCount = Array.isArray(currentQuestion.correctAnswer) && currentQuestion.correctAnswer.length > 0
            ? currentQuestion.correctAnswer.length
            : 8;

          const odflTopCount = currentQuestion.topRowCount ?? 4;
          const odflLeftCount = currentQuestion.leftColCount ?? Math.floor((odflSlotsCount - odflTopCount) / 2);
          const odflRightCount = odflSlotsCount - odflTopCount - odflLeftCount;

          const odflExpected = Array.isArray(currentQuestion.correctAnswer)
            ? currentQuestion.correctAnswer.map((item) => String(item))
            : [];

          const odflOnDragOver = (event) => event.preventDefault();

          const odflDragStartOption = (event, value) => {
            if (isAnswerChecked) return;
            event.dataTransfer.setData('text/plain', String(value));
            event.dataTransfer.effectAllowed = 'move';
          };

          const odflPlaceInSlot = (slotIndex, value) => {
            if (isAnswerChecked || value === null || value === undefined || value === '') return;
            setDataReceived((prev) => {
              const next = Array.isArray(prev) && prev.length === odflSlotsCount
                ? [...prev]
                : Array(odflSlotsCount).fill(null);
              const existingIndex = next.findIndex((item) => item === String(value));
              if (existingIndex !== -1 && existingIndex !== slotIndex) next[existingIndex] = null;
              next[slotIndex] = String(value);
              return next;
            });
            setTextButton('Verifica');
            setChangeColorButton(true);
          };

          const odflDropOnSlot = (event, slotIndex) => {
            event.preventDefault();
            if (isAnswerChecked) return;
            odflPlaceInSlot(slotIndex, event.dataTransfer.getData('text/plain'));
          };

          const odflDropOnOptions = (event) => {
            event.preventDefault();
            if (isAnswerChecked) return;
            const value = event.dataTransfer.getData('text/plain');
            if (value) setDataReceived((prev) => prev.map((item) => (item === value ? null : item)));
          };

          const odflSlotClick = (slotIndex) => {
            if (isAnswerChecked) return;
            setDataReceived((prev) => { const n = [...prev]; n[slotIndex] = null; return n; });
          };

          const odflOptionClick = (value) => {
            if (isAnswerChecked || dataReceived.includes(String(value))) return;
            const firstEmpty = dataReceived.findIndex((item) => item === null || item === undefined);
            if (firstEmpty !== -1) odflPlaceInSlot(firstEmpty, value);
          };

          const odflDragStartSlot = (event, value) => {
            if (isAnswerChecked || !value) return;
            event.dataTransfer.setData('text/plain', String(value));
            event.dataTransfer.effectAllowed = 'move';
          };

          const renderOdflSlot = (slotIndex) => {
            const value = dataReceived[slotIndex] || '';
            const expected = odflExpected[slotIndex] || '';
            const isCorrectSlot = isAnswerChecked && value && value === expected;
            const isWrongSlot = isAnswerChecked && value && value !== expected;
            return (
              <button
                key={`odfl-slot-${slotIndex}`}
                type="button"
                className={`mfl-slot-bc ${value ? 'filled' : ''} ${isCorrectSlot ? 'correct' : ''} ${isWrongSlot ? 'incorrect' : ''}`}
                onDragOver={odflOnDragOver}
                onDrop={(e) => odflDropOnSlot(e, slotIndex)}
                onClick={() => odflSlotClick(slotIndex)}
                draggable={!isAnswerChecked && Boolean(value)}
                onDragStart={(e) => odflDragStartSlot(e, value)}
                disabled={isAnswerChecked}
              >
                <span className='mfl-slot-value-bc'>{value}</span>
              </button>
            );
          };

          return (
            <div className="quiz-content-scroll-bc">
              <div className='explanation-lesoon-container-bc mfl-shell-bc'>
                <div className='title-simple-select-align-bc siple-formula-title-wrap-bc'>
                  <p className='question-text-bc siple-formula-question-bc'>{currentQuestion.question}</p>
                </div>

                {/* Top row */}
                <div className='mfl-top-row-bc'>
                  {Array.from({ length: odflTopCount }, (_, i) => renderOdflSlot(i))}
                </div>

                {/* Middle section: left column + spacer + right column */}
                <div className='mfl-middle-section-bc'>
                  <div className='mfl-col-bc'>
                    {Array.from({ length: odflLeftCount }, (_, i) => renderOdflSlot(odflTopCount + i))}
                  </div>
                  <div className='mfl-col-spacer-bc' />
                  <div className='mfl-col-bc'>
                    {Array.from({ length: odflRightCount }, (_, i) => renderOdflSlot(odflTopCount + odflLeftCount + i))}
                  </div>
                </div>

                {/* Options */}
                {!isAnswerChecked && (
                  <div
                    className='mfl-options-bc'
                    onDragOver={odflOnDragOver}
                    onDrop={odflDropOnOptions}
                  >
                    {odflNormalizedOptions.map((option) => {
                      const isUsed = dataReceived.includes(option.value);
                      return (
                        <button
                          key={option.id}
                          type="button"
                          className={`mfl-option-bc ${isUsed ? 'used' : ''}`}
                          draggable={!isUsed}
                          onDragStart={(e) => !isUsed && odflDragStartOption(e, option.value)}
                          onClick={() => !isUsed && odflOptionClick(option.value)}
                          disabled={isUsed}
                        >
                          {!isUsed && option.label}
                        </button>
                      );
                    })}
                  </div>
                )}

                <div className='position-button-lesson-bc'>
                  <button
                    className={`button-next-quiz-bc ${areAllFieldsCompleted() ? '' : 'button-next-quiz-desabled-bc'}`}
                    onClick={verifyAnswer}
                    disabled={!areAllFieldsCompleted()}
                  >
                    Verifica
                  </button>
                </div>
              </div>
            </div>
          );
        }

        case 'optionDragAndDropFormulaRight': {
          const odfrNormalizedOptions = (shuffledOptionDragAndDropFormulaRightOptions.length
            ? shuffledOptionDragAndDropFormulaRightOptions
            : (currentQuestion.options || [])
          ).map((option, index) => {
            if (option && typeof option === 'object') {
              const value = option.code ?? option.value ?? option.label ?? '';
              const label = option.label ?? option.code ?? option.value ?? '';
              return { id: option.id ?? `${String(value)}-${index}`, value: String(value), label: String(label) };
            }
            return { id: `${String(option)}-${index}`, value: String(option), label: String(option) };
          });

          const odfrSlotsCount = Array.isArray(currentQuestion.correctAnswer) && currentQuestion.correctAnswer.length > 0
            ? currentQuestion.correctAnswer.length
            : 8;

          const odfrTopCount = currentQuestion.topRowCount ?? 4;
          const odfrRemaining = Math.max(0, odfrSlotsCount - odfrTopCount);
          const odfrMidLeftCount = currentQuestion.rightInnerColCount ?? Math.floor(odfrRemaining / 2);
          const odfrMidRightCount = odfrRemaining - odfrMidLeftCount;

          const odfrExpected = Array.isArray(currentQuestion.correctAnswer)
            ? currentQuestion.correctAnswer.map((item) => String(item))
            : [];

          const odfrOnDragOver = (event) => event.preventDefault();

          const odfrDragStartOption = (event, value) => {
            if (isAnswerChecked) return;
            event.dataTransfer.setData('text/plain', String(value));
            event.dataTransfer.effectAllowed = 'move';
          };

          const odfrPlaceInSlot = (slotIndex, value) => {
            if (isAnswerChecked || value === null || value === undefined || value === '') return;
            setDataReceived((prev) => {
              const next = Array.isArray(prev) && prev.length === odfrSlotsCount
                ? [...prev]
                : Array(odfrSlotsCount).fill(null);
              const existingIndex = next.findIndex((item) => item === String(value));
              if (existingIndex !== -1 && existingIndex !== slotIndex) next[existingIndex] = null;
              next[slotIndex] = String(value);
              return next;
            });
            setTextButton('Verifica');
            setChangeColorButton(true);
          };

          const odfrDropOnSlot = (event, slotIndex) => {
            event.preventDefault();
            if (isAnswerChecked) return;
            odfrPlaceInSlot(slotIndex, event.dataTransfer.getData('text/plain'));
          };

          const odfrDropOnOptions = (event) => {
            event.preventDefault();
            if (isAnswerChecked) return;
            const value = event.dataTransfer.getData('text/plain');
            if (value) setDataReceived((prev) => prev.map((item) => (item === value ? null : item)));
          };

          const odfrSlotClick = (slotIndex) => {
            if (isAnswerChecked) return;
            setDataReceived((prev) => { const n = [...prev]; n[slotIndex] = null; return n; });
          };

          const odfrOptionClick = (value) => {
            if (isAnswerChecked || dataReceived.includes(String(value))) return;
            const firstEmpty = dataReceived.findIndex((item) => item === null || item === undefined);
            if (firstEmpty !== -1) odfrPlaceInSlot(firstEmpty, value);
          };

          const odfrDragStartSlot = (event, value) => {
            if (isAnswerChecked || !value) return;
            event.dataTransfer.setData('text/plain', String(value));
            event.dataTransfer.effectAllowed = 'move';
          };

          const renderOdfrSlot = (slotIndex) => {
            const value = dataReceived[slotIndex] || '';
            const expected = odfrExpected[slotIndex] || '';
            const isCorrectSlot = isAnswerChecked && value && value === expected;
            const isWrongSlot = isAnswerChecked && value && value !== expected;
            return (
              <button
                key={`odfr-slot-${slotIndex}`}
                type="button"
                className={`mfl-slot-bc ${value ? 'filled' : ''} ${isCorrectSlot ? 'correct' : ''} ${isWrongSlot ? 'incorrect' : ''}`}
                onDragOver={odfrOnDragOver}
                onDrop={(e) => odfrDropOnSlot(e, slotIndex)}
                onClick={() => odfrSlotClick(slotIndex)}
                draggable={!isAnswerChecked && Boolean(value)}
                onDragStart={(e) => odfrDragStartSlot(e, value)}
                disabled={isAnswerChecked}
              >
                <span className='mfl-slot-value-bc'>{value}</span>
              </button>
            );
          };

          return (
            <div className="quiz-content-scroll-bc">
              <div className='explanation-lesoon-container-bc mfl-shell-bc'>
                <div className='title-simple-select-align-bc siple-formula-title-wrap-bc'>
                  <p className='question-text-bc siple-formula-question-bc'>{currentQuestion.question}</p>
                </div>

                <div className='mfl-top-row-bc'>
                  {Array.from({ length: odfrTopCount }, (_, i) => renderOdfrSlot(i))}
                </div>

                <div className='mfr-middle-section-bc'>
                  <div className='mfr-col-spacer-bc' />
                  <div className='mfr-col-bc'>
                    {Array.from({ length: odfrMidLeftCount }, (_, i) => renderOdfrSlot(odfrTopCount + i))}
                  </div>
                  <div className='mfr-col-bc'>
                    {Array.from({ length: odfrMidRightCount }, (_, i) => renderOdfrSlot(odfrTopCount + odfrMidLeftCount + i))}
                  </div>
                </div>

                {!isAnswerChecked && (
                  <div
                    className='mfl-options-bc'
                    onDragOver={odfrOnDragOver}
                    onDrop={odfrDropOnOptions}
                  >
                    {odfrNormalizedOptions.map((option) => {
                      const isUsed = dataReceived.includes(option.value);
                      return (
                        <button
                          key={option.id}
                          type="button"
                          className={`mfl-option-bc ${isUsed ? 'used' : ''}`}
                          draggable={!isUsed}
                          onDragStart={(e) => !isUsed && odfrDragStartOption(e, option.value)}
                          onClick={() => !isUsed && odfrOptionClick(option.value)}
                          disabled={isUsed}
                        >
                          {!isUsed && option.label}
                        </button>
                      );
                    })}
                  </div>
                )}

                <div className='position-button-lesson-bc'>
                  <button
                    className={`button-next-quiz-bc ${areAllFieldsCompleted() ? '' : 'button-next-quiz-desabled-bc'}`}
                    onClick={verifyAnswer}
                    disabled={!areAllFieldsCompleted()}
                  >
                    Verifica
                  </button>
                </div>
              </div>
            </div>
          );
        }

        case 'lessonResume':
  if (finalMessage) {
    return null;
  }

return (
  <div className='explanation-lesoon-container-resume-bc'>
    <div className="description-lesson-text-explanation-resume">
      
      <h2 className="motivational-title">{currentQuestion.titleExplanation}</h2>

      <div className='container-resume-lesson-bc'>
        {currentQuestion.descriptionExplanation.map((description, index) => (
          <div
            key={index}
            className="summary-info-line-bc"
            style={{ animationDelay: `${index * 0.3}s` }}
          >

            <div>
              <FontAwesomeIcon 
                icon={faCheckDouble} 
                className="summary-icon-resume-bc"
              />
            </div>

            <div
              className="text-size-emplanation-resume-bc"
              dangerouslySetInnerHTML={{ __html: description }}
            ></div>

          </div>
        ))}
      </div>

{showRatingSection && (

<div className='feedback-resume-bc rating-appear'>
  <h3>Evaluezi lectia la:</h3>

  <div className="star-rating-container">
    {[1,2,3,4,5].map((star) => (
      <div className="star-wrapper" key={star}>
        <FontAwesomeIcon
          icon={faStar}
          className={`star-rating-item ${selectedRating >= star ? 'active' : ''}`}
          onClick={() => handleRating(star)}
        />

     
        
      </div>
    ))}
  </div>

  {/* Mesaj dinamic */}
{showRatingMessage && (
  <p
    key={"rating-msg-" + selectedRating}
    className={`rating-message ${showRatingMessage ? "show" : ""}`}
  >
    Multumim! 🤗
  </p>
)}




</div>

)}

    </div>
  </div>
);

case 'lessonCompletion':
  return (
    <div className='explanation-lesoon-container-resume-bc'>
      <div className="description-lesson-text-explanation-resume">

     

        {/* 🔥 GIF progres final peste tot */}
        <div className="lesson-progress-overlay">
          <img
            src={finallessonprogress}
            alt="Progres lectie"
            className="lesson-progress-overlay-image"
          />
        </div>

        {currentQuestion.descriptionExplanation.map((desc, index) => (
          <div
            key={index}
            className="text-size-emplanation-resume-bc"
            dangerouslySetInnerHTML={{ __html: desc }}
          />
        ))}

        {/* 🎉 Speech bubble cu mesaj de succes */}
        <div className="success-message-bubble bubble-slide-in-left">
          Felicitari!
        </div>

        <div className="lesson-image-container">
          <img
            src={final_congrats_conti}
            alt="Felicitari finale"
            className="lesson-image-finishandsend"
          />
        </div>

        {/* 🔥 Bara de progres - finalizare lectie */}
        <div className="lesson-completion-progress-wrapper">
          <p className="completion-progress-label">Lectie finalizata!</p>
          <div className="lesson-completion-progress-bar">
            <div
              className="lesson-completion-progress-fill"
              onAnimationEnd={() => setIsLessonCompletionBarDone(true)}
            ></div>
            
          </div>
        </div>

      </div>
    </div>
  );




          case 'JustInTimeMotivation':
  return (
   
      <div className='explanation-lesoon-container-resume-bc'>
      <div className="description-lesson-text-explanation-resume">
          {currentQuestion.descriptionExplanation.map((explanation, index) => (
            <div
              key={index}
              className="text-size-emplanation-bc"
              dangerouslySetInnerHTML={{ __html: explanation }}
            ></div>
          ))}
          
        <MotivationStats
  coins={lessonCoins}
  xp={lessonXp}
  correct={correctAnswersCount}
  wrong={wrongAnswersCount}
/>

    
        </div>
      </div>
    
  );

          
  case 'serieCompleta':
  return (
    
      <div className='explanation-lesoon-container-resume-bc'>
      <div className="description-lesson-text-explanation-resume">
          <h2 className="motivational-title">{currentQuestion.titleExplanation}</h2>
        
        
            <div className="lesson-image-container">
            <StreakDisplay />
            </div>
          
        </div>
      </div>
    
  );

  case 'deblocarePremium':
  return (
   
      <div className='explanation-lesoon-container-resume-bc'>
      <div className="description-lesson-text-explanation-resume">
          <h2 className="motivational-title">{currentQuestion.titleExplanation}</h2>
          
          
           <div className="lesson-image-container">

  {/* LISTA BENEFICII PREMIUM */}
  <div className="premium-benefits-box">
    <div className="premium-benefit-item">
      <span className="premium-check">✔</span> Acces la lecțiile standard
    </div>
    <div className="premium-benefit-item">
      <span className="premium-check">✔</span> Acces la lecțiile de practică
    </div>
    <div className="premium-benefit-item">
      <span className="premium-check">✔</span> Acces la aplicații
    </div>
    <div className="premium-benefit-item">
      <span className="premium-check">✔</span> Acces la testele de final de capitol
    </div>
    <div className="premium-benefit-item">
      <span className="premium-check">✔</span> Certificat de finalizare a cursului
    </div>
  </div>

  {/* BUTOANE */}
  <div className="premium-buttons">
    <button className="premium-activate-btn">Activează acum</button>
    <button className="premium-remind-btn">Amintește-mi mai târziu</button>
  </div>

</div>

          
        </div>
      </div>
   
  );

  case 'clasament':
  return (
    <div className='explanation-lesoon-container-resume-bc'>
      <div className="description-lesson-text-explanation-resume">

        <h2 className="motivational-title">Clasament XP</h2>

        <Leaderboard />   {/* 🔥 Componenta nouă */}

      </div>
    </div>
  );



      default:
        return <p>Tipul întrebării nu este recunoscut.</p>;
    }

    

  };


  const currentQuestion = lessonData?.questions?.[nextQuestion];




// 🔹 DOAR pentru explanationLesson (UI logic)
const totalCards =
  currentQuestion?.type === 'explanationLesson'
    ? currentQuestion.descriptionExplanation.length
    : 0;


const currentExplanation = (() => {
  if (!currentQuestion) return null;

  if (currentQuestion.type === 'decisionFlowApplication') {
    return currentQuestion.steps?.[decisionStepIndex]?.explanation || null;
  }

  return currentQuestion.explanation || null;
})();

const isWaitingTopProgress =
  !isLessonFinished &&
  !noTransitionTypes.includes(currentType) &&
  (!isTopProgressReady || pendingLessonCompletionAdvance);

const contentTransitionKey =
  currentType === 'decisionFlowApplication'
    ? `${nextQuestion}-${decisionPhase}-${decisionStepIndex}`
    : `${nextQuestion}`;

const showDecisionFlowContextButton =
  currentQuestion?.type === 'decisionFlowApplication' &&
  decisionPhase === 'steps' &&
  textButton === 'Verifica';



  return (

 
    
    <div className='container-bc-general'>
  
      {/* Bara de progres */}
      <div className='position-progress-bar'>
        {!isLessonFinished && !showJumpHereIntro && (

         
        <StatusProgres 
  width={calculateProgress()}
  coinCount={coinCount}
  onExitClick={handleExitClick}
  onEyeClick={handleShowEyePopup}
  livesCount={lives}   
  lessonType={currentType}
  onProgressAnimationStateChange={setIsTopProgressReady}

/>

          
           
        )}




      </div>
  
      {/* Conținutul principal al lecției - păstrat vizibil indiferent de starea isLessonFinished */}


{showJumpHereIntro ? (
  <div className='position-main-lesson-bc'>
    <div className='jump-here-intro-container-bc'>
      <img
        src={Junphereconti}
        alt='Jump Here'
        className='jump-here-intro-image-bc'
      />
      <div className='jump-here-intro-actions-bc'>
        <button
          className='jump-here-intro-later-btn-bc'
          onClick={() => navigate('/functionalpagelogin')}
        >
          Poate mai tarziu
        </button>

        <button
          className='button-next-quizbc jump-here-intro-start-btn-bc'
          onClick={() => setShowJumpHereIntro(false)}
        >
          Incepe
        </button>
      </div>
    </div>
  </div>
) : (
  <SwitchTransition mode="out-in">
    <CSSTransition key={contentTransitionKey} timeout={300} classNames="fade">
      <div className='position-main-lesson-bc'>
        {renderContent()}
      </div>
    </CSSTransition>
  </SwitchTransition>
)}




  
      {/* Secțiunea butonului */}


  {!showJumpHereIntro && (
  <div className={`position-button-lesson-bc ${hideActionButton ? 'hide hide-border-top' : ''}`}>

        {showCorrectAnswer && (
          <p className='answer-show-after-button'>
            {isAnswerChecked && simpleCorrectAnswer}
          </p>
        )}
  
       


<div className={`button-group-navigationbc ${hideActionButton ? 'hide' : ''}`}>






<div className="lesson-navigation-row">

  {/* ✅ BUTON DOAR PENTRU explanationLesson */}



  
{/* Butonul care se schimbă între "Continuă" și "Finalizează lecția" */}
{currentQuestion?.type !== 'explanationLesson' && (
  (() => {
    const isWaitingLessonCompletionBar =
      isLessonFinished &&
      currentQuestion?.type === 'lessonCompletion' &&
      !isLessonCompletionBarDone;

    return (
  <button
    className={
      (desableButon || isWaitingLessonCompletionBar || isWaitingTopProgress)
        ? 'button-next-quizbc-desabled'
        : changeColorButton
        ? 'button-next-quizbc-verify'
        : 'button-next-quizbc'
    }
    disabled={desableButon || isWaitingLessonCompletionBar || isWaitingTopProgress}
onClick={() => {

  if (isWaitingTopProgress) {
    return;
  }

  // 🔥 1️⃣ FINAL LECȚIE – PRIMUL
  if (isLessonFinished) {
    if (isWaitingLessonCompletionBar) {
      return;
    }
    finalizeLesson();
    return;
  }

  const currentQuestion = lessonData.questions[nextQuestion];

  // 2️⃣ TIPURI INFORMATIVE
  if (
  currentQuestion.type === 'JustInTimeMotivation' ||
  currentQuestion.type === 'serieCompleta' ||
  currentQuestion.type === 'deblocarePremium' ||
  currentQuestion.type === 'clasament'
)
 {
    toNextQuestion();
    setHideActionButton(false);
    return;
  }

  // 3️⃣ lessonCompletion
if (
  currentQuestion.type === 'lessonCompletion' &&
  !lessonCompletionSentRef.current
) {

  sendLessonCompletion(currentQuestion.type);

  const lessonType =
    (lessonData?.explanationType || '').toLowerCase();

  const isApplication = lessonType === 'aplicatie';
  const isLesson = lessonType === 'lectie';

  updateDailyMissions({
    lesson: isLesson ? 1 : 0,
    application: isApplication ? 1 : 0
  });

  if (lessonXp > 0) sendLessonFinishXp(lessonXp);
  if (lessonCoins > 0) addCoins(lessonCoins);

  lessonCompletionSentRef.current = true;

  setDesableButton(true);
  toNextQuestion();
  return;
}

  // 4️⃣ decisionFlowApplication
  if (currentQuestion.type === 'decisionFlowApplication') {
    if (decisionPhase === 'intro') {
      setDecisionPhase('steps');
      setDecisionAnswer(null);
      setDecisionSelectedAnswers([]);
      setDecisionDragAnswer([]);
      setIsAnswerChecked(false);
      setAnswerStatus(null);
      setDesableButton(true);
      setTextButton('Verifica');
      setChangeColorButton(false);
      setHideActionButton(false);
      return;
    }

    if (decisionPhase === 'final') {
      toNextQuestion();
      setHideActionButton(false);
      return;
    }

    if (decisionPhase === 'steps') {
      verifyAnswer();
      setHideActionButton(true);
      setShowFeedback(true);
      return;
    }

    return;
  }

  // 5️⃣ quiz normal
  if (isAnswerChecked) {
    toNextQuestion();
    setHideActionButton(false);
  } else {
    verifyAnswer();
    setHideActionButton(true);
    setShowFeedback(true);
  }
}}

  >
    {isLessonFinished && finalMessage ? (
      'urmatoarea lectie'
    ) : (
      <>
        <span>{textButton || 'Continua'}</span>
        {showDecisionFlowContextButton && (
          <span className="practice-steps-bc">
            {decisionStepIndex + 1} / {currentQuestion?.steps?.length || 0}
          </span>
        )}
      </>
    )}
  </button>
    );
  })()
)}


{currentQuestion?.type === 'explanationLesson' && (
  currentQuestion.descriptionExplanation && currentQuestion.descriptionExplanation.length === 1 ? (
    <button
      className="button-explanation-continue-single"
      onClick={() => {
        toNextQuestion();
        setHideActionButton(false);
      }}
    >
      Continua
    </button>
  ) : (
    <button
      className="button-explanation-continue-multi"
      onClick={() => {
        toNextQuestion();
        setHideActionButton(false);
      }}
    >
      Continua
    </button>
  )
)}

  {/* 🔹 BUTON CARDURI – DOAR PENTRU explanationLesson */}
{currentQuestion?.type === 'explanationLesson' && currentQuestion.descriptionExplanation && currentQuestion.descriptionExplanation.length > 1 && (
  <button
    className="button-next-card-bc"
    onClick={() => {
      const targetIndex = (cardIndex + 1) % totalCards;
      updateCardIndexWithSwipe(targetIndex);
    }}
  >
    <img src={changecard} alt="Schimbă cardul" className="change-card-gif-bc" />
  </button>
)}

{showDecisionFlowContextButton && (
  <button
    className="button-next-card-decision-bc"
    onClick={() => setShowPracticeHelp(true)}
    title="Contextul aplicației"
  >
    <img src={changecard} alt="Vezi contextul" className="change-card-gif-bc" />
  </button>
)}

     </div>
</div>


      </div>
      )}



  
      {/* Alerta de părăsire a lecției */}
   {showAlert && (
  <CustomAlert
    onConfirm={handleConfirmExit}
    onCancel={handleCancelExit}
  />
)}



{showFeedback && isAnswerChecked && (
  <FeedbackPopup
    status={answerStatus}
     messageCorrect={correctStreak === 5 ? "5 la rând!" : "Corect!"}
  xpAmount={correctStreak === 5 ? 30 : 10}   // 🔥 trimitem XP corect
  isStreakBonus={correctStreak === 5}
    message={message}
    chapterId={chapterId}
    lessonId={lessonId}
    questionIndex={nextQuestion}   // 🔥 cheia pentru comentarii pe fiecare întrebare
    onClose={handleHideFeedback}
    onContinue={() => {
 

  if (correctStreak === 5) {
    setCorrectStreak(0);
  }

  const currentQuestion = lessonData.questions[nextQuestion];

  // 🔥 DACĂ SUNTEM ÎN decisionFlowApplication
if (currentQuestion.type === 'decisionFlowApplication') {
  handleHideFeedback();

  // după feedback -> pas următor / final
  if (decisionStepIndex < currentQuestion.steps.length - 1) {
    setDecisionStepIndex(prev => prev + 1);
    setDecisionAnswer(null);
    setDecisionSelectedAnswers([]);
    setDecisionDragAnswer([]);
    setIsAnswerChecked(false);
    setAnswerStatus(null);
    setDesableButton(true);
    setTextButton('Verifica');
    setChangeColorButton(false);
  } else {
    setDecisionPhase('final');
    setDecisionAnswer(null);
    setDecisionSelectedAnswers([]);
    setDecisionDragAnswer([]);
    setIsAnswerChecked(false);
    setAnswerStatus(null);
    setDesableButton(false);
    setTextButton('Continua');
    setChangeColorButton(false);
  }

  setHideActionButton(false);
  return;
}



  // 🔥 RESTUL QUIZURILOR
  toNextQuestion();
  setHideActionButton(false);
}}


    onShowAnswer={() => {
      setShowExplanationPopupModal(true);
      handleHideFeedback();
    }}
  />
)}



{showExplanationPopupModal && currentExplanation && (

  <ExplanationPopup
  explanation={currentExplanation}
  onContinue={() => {
    setShowExplanationPopupModal(false);

    const currentQuestion = lessonData.questions[nextQuestion];

    if (currentQuestion.type === 'decisionFlowApplication') {
      const steps = currentQuestion.steps;

      if (decisionStepIndex < steps.length - 1) {
        setDecisionStepIndex(prev => prev + 1);
        setDecisionAnswer(null);
        setDecisionSelectedAnswers([]);
        setDecisionDragAnswer([]);
        setIsAnswerChecked(false);
        setAnswerStatus(null);
        setDesableButton(true);
        setTextButton('Verifica');
        setChangeColorButton(false);
      } else {
        setDecisionPhase('final');
        setDecisionAnswer(null);
        setDecisionSelectedAnswers([]);
        setDecisionDragAnswer([]);
        setIsAnswerChecked(false);
        setAnswerStatus(null);
        setDesableButton(false);
        setTextButton('Continua');
        setChangeColorButton(false);
      }

      setHideActionButton(false);
      return;
    }

    // 🔥 restul quizurilor
    toNextQuestion();
    setHideActionButton(false);
  }}
/>

)}

{showNoLivesPopup && (
  <NoLivesPopup
    onClose={() => navigate('/functionalpagelogin')}
  />
)}


{showPracticeHelp && (
  <PracticeHelpPopup
    text={currentQuestion.context}
    onClose={() => setShowPracticeHelp(false)}
  />
)}





    </div>
  );
  



  
};



export default Chaptercontainer;